// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:14:07.722Z
// Property: 51 at Southaven (ID: 6737460151192624)
// Collections: 25 amenities, 9 floorplans (live), 45 photos, 43 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192624",
  "property_external_id": "4707218",
  "property_zillow_url": "https://www.zillow.com/homedetails/7560-Chesteridge-Ave-Southaven-MS-38671/338745075_zpid/",
  "property_apartments_url": "https://www.apartments.com/51-at-southhaven-southaven-ms/3y3yjhg",
  "property_google_business_url": "https://www.google.com/maps/place/51+@+Southaven/data=!4m2!3m1!1s0x0:0x7c38a0731431a8d2?sa=X&ved=2ahUKEwjmq7zixLySAxVy5ckDHZcuOeoQ_BJ6BAg1EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321184433",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "51-at-southaven",
  "property_name": "51 at Southaven",
  "property_website_url": "https://www.51atsouthaven.com/",
  "property_domain": "https://www.51atsouthaven.com/",
  "property_address": "7560 Chesteridge Ave",
  "property_full_address": "7560 Chesteridge Ave, Southaven, MS 38671",
  "property_address_1": "7560 Chesteridge Ave",
  "property_address_2": null,
  "property_address_city": "Southaven",
  "property_address_state": "MS",
  "property_address_zip_full": "38671-5517",
  "property_address_zip": "38671",
  "property_address_country": "US",
  "property_address_county": "DeSoto County",
  "property_neighborhood_address": "West End",
  "property_address_latitude": "34.9706424",
  "property_address_longitude": "-90.0110756",
  "property_email": "51southaven@rreafresidential.com",
  "property_phone": "(662) 342-9000",
  "property_call_tracking_phone": "662-667-1146",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover modern living at 51 at Southaven in Southaven, MS! Choose from spacious one, two, or three-bedroom floor plans. Enjoy fantastic amenities like a refreshing pool, fitness center, and a Zen garden. Find your new home today—browse our availability or schedule a tour to explore our vibrant community!",
  "property_long_description": "Welcome to 51 at Southaven, where modern living meets unparalleled convenience in the heart of Southaven, MS. Our luxurious apartment community offers an array of beautifully designed floor plans, including spacious one, two, and three-bedroom options that cater to every lifestyle. Whether you're seeking a cozy retreat or ample space for family and friends, we have the perfect home for you.\n\nEnjoy a wealth of exceptional amenities that elevate your living experience at 51 at Southaven. Dive into relaxation at our shimmering pool, or get your heart pumping in our state-of-the-art fitness center. The clubhouse provides a welcoming space for social gatherings, while our game room and multi-use room offer fun-filled leisure opportunities. With our planned social activities, you’re sure to connect with neighbors and make lasting memories.\n\nFor the environmentally conscious, we’re proud to offer recycling options, EV charging stations, and stunning walking/biking trails that allow you to embrace nature. Additional conveniences include on-site maintenance and a property manager dedicated to ensuring your comfort. Enjoy the benefits of community-wide WiFi, package service, bicycle storage, and a pet washing station that makes living with your furry friends worry-free.\n\nAt 51 at Southaven, you can unwind in our serene Zen garden, relax on the sundeck, or utilize our conference and business center for productivity. Experience the ultimate blend of luxury and community living — find your new home today by browsing our availability or scheduling a tour of our vibrant community!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-5f3f-70cd-9920-23ad59f459ff.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with yellow lounge chairs and a black fence.",
    "public_id": "019e60b3-5f3f-70cd-9920-23ad59f459ff",
    "storage_key": "property/6737460151192624/019e60b3-5f3f-70cd-9920-23ad59f459ff.webp",
    "width": 2000,
    "height": 1333
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "430",
  "property_year_built": "1996",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.09302325581396",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "One-Time Move-In Fees\nAdministrative Fee\n$50\nApplication Fee\n$65",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "40",
  "property_pet_restrictions": "We welcome 2 pets per apartment home. Pet fee is $250 per pet.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://51atsouthaven.loftliving.com/login",
  "property_apply_now_url": "https://8444225.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e1de5-118a-7544-89f9-2330ba17f70e.webp",
  "property_primary_logo_media": {
    "alt_text": "51 Southaven Apartment Homes logo",
    "public_id": "019e1de5-118a-7544-89f9-2330ba17f70e",
    "storage_key": "property/6737460151192624/019e1de5-118a-7544-89f9-2330ba17f70e.webp",
    "width": 1100,
    "height": 400
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e1de5-118a-7544-89f9-2330ba17f70e.webp",
  "property_secondary_logo_media": {
    "alt_text": "51 Southaven Apartment Homes logo",
    "public_id": "019e1de5-118a-7544-89f9-2330ba17f70e",
    "storage_key": "property/6737460151192624/019e1de5-118a-7544-89f9-2330ba17f70e.webp",
    "width": 1100,
    "height": 400
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e8e87-4a26-73c8-aef1-4b9610f8c2c6.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-4a26-73c8-aef1-4b9610f8c2c6",
    "storage_key": "property/6737460151192624/019e8e87-4a26-73c8-aef1-4b9610f8c2c6.webp",
    "width": 1100,
    "height": 400
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e8e87-3d58-76fa-ab9a-6384ec1eef90.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-3d58-76fa-ab9a-6384ec1eef90",
    "storage_key": "property/6737460151192624/019e8e87-3d58-76fa-ab9a-6384ec1eef90.webp",
    "width": 1100,
    "height": 400
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#103775",
  "property_secondary_color": "#b8d0ea",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "711 - 1063",
  "property_sqft_min": "711",
  "property_sqft_max": "1063",
  "property_price_range": "999 - 1525",
  "property_price_min": "999",
  "property_price_max": "1525",
  "property_available_units": 34,
  "property_facebook_url": "https://www.facebook.com/51atSouthaven/",
  "property_instagram_url": "https://www.instagram.com/51_at_southaven/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJN6sIVBJi1YcR0qgxFHOgOHw",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=Southaven%2C+MS",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to 51 at Southaven",
  "property_home_romance_title": "Embrace a Life of Love and Comfort at Our Community",
  "property_home_amenities_blurb": "<p>51 at Southaven is setting a new trend in affordable apartment living! Our charming <a href=\"/floor-plans/\">apartment home</a> community, ideally located in <a href=\"/neighborhood/\">Southaven, Mississippi</a>, is everything you have always dreamed of and more. Conveniently situated near major thoroughfares, any destination is easily accessible, and we are surrounded by a myriad of retail and restaurant options, ensuring that everything you need is within reach. Only minutes away, you’ll find Memphis and the excitement of the big city, or for those days when you seek serenity, nearby parks are in abundance. Discover endless possibilities at 51 at Southaven in Southaven, Mississippi!</p>",
  "property_home_floorplans_blurb": "<p>51 at Southaven is the perfect destination for FedEx, Amazon, and Baptist Memorial Hospital-DeSoto employees. Just 13 miles south of Memphis, Southaven offers a convenient commute while blending rural beauty with suburban amenities. Enjoy vast green spaces and serene neighborhoods alongside top-notch shopping and dining at Southaven Towne Center and Tanger Outlets Southaven.</p>\n<p>Our apartments at 51 at Southaven provide <a href=\"/amenities/\">modern amenities</a>, peaceful living, and a welcoming community, all in a prime location near major employers. Experience the best in suburban living and make your move to 51 at Southaven today. <a href=\"/contact/\">Contact us</a> now to find your new home!</p>",
  "property_home_gallery_blurb": "At 51 at Southaven, your ideal home awaits amidst modern amenities and spacious floor plans. Choose from one, two, or three-bedroom apartments featuring high-speed internet, a refreshing pool, and a state-of-the-art fitness center. Picture yourself relaxing in the clubhouse or enjoying a game on the basketball court!",
  "property_home_neighborhood_blurb": "Discover your perfect home at 51 at Southaven, where our diverse floor plans feature stylish one, two, and three-bedroom apartments. Nestled in Southaven, MS, you'll enjoy modern living with access to vibrant local favorites. Explore nearby points of interest and see what makes our community truly special!",
  "property_home_reviews_blurb": "At 51 at Southaven, residents praise the vibrant community and modern amenities, saying it feels like “home from the moment you walk in.” Nestled in beautiful Southaven, MS, our inviting atmosphere and thoughtful design make everyday living a joy. See what our residents have to say about living here!",
  "property_neighborhood_blurb": "<p>51 at Southaven is the perfect destination for FedEx, Amazon, and Baptist Memorial Hospital-DeSoto employees. Just 13 miles south of Memphis, Southaven offers a convenient commute while blending rural beauty with suburban amenities. Enjoy vast green spaces and serene neighborhoods alongside top-notch shopping and dining at Southaven Towne Center and Tanger Outlets Southaven.</p>\n<p>Our apartments at 51 at Southaven provide <a href=\"/amenities/\">modern amenities</a>, peaceful living, and a welcoming community, all in a prime location near major employers. Experience the best in suburban living and make your move to 51 at Southaven today. <a href=\"/contact/\">Contact us</a> now to find your new home!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Outside your door, you’ll find retreat-like living that is refreshing and rejuvenating. Exercise anytime in our state-of-the-art fitness center, or unwind in one of our three shimmering swimming pools. We cater to your every need, featuring a business center with complimentary printing and three on-site laundry facilities to make laundry care easy. Our professional management team is on site and dedicated to providing <a href=\"/contact/\">excellent customer service</a>, and our maintenance team is on call 24 hours a day. Call us today to schedule a tour and you’ll see why 51 at Southaven in Southaven, Mississippi is apartment living beyond compare!</p>",
  "property_applynow_blurb": "Discover your perfect home at 51 at Southaven! Choose from spacious one, two, or three-bedroom floor plans, and enjoy exceptional amenities like a pool, fitness center, and Zen garden. With business center access and planned social activities, it’s community living redefined. Find your new home and lease online today!",
  "property_contactus_blurb": "Discover the ideal living space at 51 at Southaven in Southaven, MS. Choose from our variety of floor plans, including one, two, and three-bedroom options tailored to fit your lifestyle. Have questions? Contact our leasing team today and take the first step toward your new home!",
  "property_faqs_blurb": "Discover your perfect home at 51 at Southaven, offering a range of thoughtfully designed floor plans, including one, two, and three-bedroom options. Have questions? Browse our FAQs page for answers about our vibrant community and amenities in Southaven, MS. Your ideal living experience awaits!",
  "property_floorplans_blurb": "<p>Choose from spacious one, two, and three bedroom apartment homes for rent in Southaven. Each home interior is <a href=\"/gallery/\">meticulously designed</a> to inspire awe, beginning with updated, modern kitchens that feature a breakfast bar and refrigerator. Imagine coming home to the warmth of immaculate hardwood and carpeted flooring and the <a href=\"/amenities/\">elegance of vaulted ceilings</a>. We are a pet-friendly community and look forward to greeting your entire family with true Southern hospitality.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "Discover your ideal home at 51 at Southaven, where our diverse floor plans—one, two, and three-bedroom options—cater to your lifestyle. Enjoy top-notch amenities including a resort-style pool, fitness center, and Zen garden. Use our interactive community map to explore available apartments and pricing today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "Discover your perfect home at 51 at Southaven, where our diverse floor plans include one-, two-, and three-bedroom options. Enjoy a vibrant community in Southaven, MS. Great friends make great neighbors—refer a friend to our community today and experience the comfort and camaraderie of apartment living together!",
  "property_residentaccess_blurb": "Welcome to 51 at Southaven, your ideal home in Southaven, MS! Choose from stylish one, two, or three-bedroom floor plans tailored for comfort. Access your resident portal today for seamless rent payments, hassle-free maintenance requests, and more. Experience convenient living—login now and embrace your new lifestyle!",
  "property_reviews_blurb": "At 51 at Southaven, our residents rave about the “spacious layouts and friendly atmosphere.” Nestled in the heart of Southaven, MS, our vibrant community offers the perfect blend of comfort and convenience. Read firsthand accounts of living here and see why our apartment community feels like home. ",
  "property_created_at": "1752257252398",
  "property_scheduletour_blurb": "Discover your perfect home at 51 at Southaven in Southaven, MS! Offering spacious one, two, and three-bedroom floor plans, our community has options to fit every lifestyle. Schedule a tour today and see what our residents have to say about living here! Your dream apartment awaits!",
  "property_thankyou_blurb": "Thank you for your interest in 51 at Southaven! Explore our thoughtfully designed one, two, and three-bedroom floor plans in beautiful Southaven, MS. Your new home awaits! Our team will contact you shortly to assist with your apartment search. Stay tuned for exciting updates and information!",
  "property_virtualtours_blurb": "<p>At 51 at Southaven, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. 51 at Southaven",
  "property_seo_title_home": "51 at Southaven | Apartments in Southaven, MS",
  "property_seo_description_home": "Discover your perfect home at 51 at Southaven in Southaven, MS. Choose from our spacious one, two, and three-bedroom floor plans and enjoy top-notch amenities including a refreshing pool, modern fitness center, and inviting clubhouse. With features like EV charging, a pet washing station, and community-wide WiFi, we cater to your every need. Plus, participate in planned social activities or relax in the serene Zen garden. Find your new home today and experience the vibrant lifestyle you deserve!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Southaven, MS",
  "property_seo_description_floorplans": "Discover your ideal living space at 51 at Southaven in Southaven, MS! Explore our diverse floor plans, including one-bedroom, two-bedroom, and three-bedroom apartments tailored to your lifestyle. Browse our available apartment homes today and find the perfect floor plan that suits you. Your dream apartment awaits!",
  "property_seo_title_amenities": "Amenities | Southaven, MS Apartments for Rent",
  "property_seo_description_amenities": "Discover your new home at 51 at Southaven in Southaven, MS! Choose from spacious one, two, and three-bedroom floor plans, complemented by exceptional amenities including a refreshing pool, fitness center, and inviting clubhouse. Enjoy conveniences like business center access, EV charging, and dedicated maintenance staff, plus community-wide WiFi and planned social activities! Relax in our serene Zen garden or host a barbecue at the grill area. Ready to elevate your living experience? Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Southaven, MS",
  "property_seo_description_gallery": "Discover your dream home at 51 at Southaven in Southaven, MS! Explore our stunning photo gallery featuring spacious one, two, and three-bedroom floor plans. Enjoy resort-style amenities including a refreshing pool, modern fitness center, and tranquil Zen garden. With a clubhouse, business center, and fun gameroom, there's something for everyone. Picture yourself living here and embrace a vibrant community with planned social activities, walking/biking trails, and pet-friendly features. Experience comfort and convenience with on-site maintenance, EV charging, and secure key fob entry. Your ideal lifestyle awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | 51 at Southaven Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at 51 at Southaven in Southaven, MS! Explore our variety of spacious floor plans, including one, two, and three-bedroom apartments. Enjoy modern amenities and a vibrant community atmosphere. Take a virtual tour of our beautiful apartments for rent today! ",
  "property_seo_title_interactivemap": "Interactive Map | 51 at Southaven Apartments",
  "property_seo_description_interactivemap": "\"Discover your perfect home at 51 at Southaven in Southaven, MS! Explore our spacious one, two, and three-bedroom floor plans, and indulge in premium amenities such as a refreshing pool, state-of-the-art fitness center, and serene Zen garden. Enjoy community-wide WiFi, planned social activities, and a dedicated maintenance team for your peace of mind. Use our interactive community map to search available apartments, view pricing, and start your new lifestyle today!\"",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Southaven, MS",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood of 51 at Southaven, your ideal apartment community in Southaven, MS. Explore our spacious floor plans, featuring one, two, and three-bedroom options. Dive into the local favorites and nearby points of interest that make living here truly special. See what's around our community and experience the perfect blend of comfort and convenience today!",
  "property_seo_title_contact": "Contact Us | 51 at Southaven",
  "property_seo_description_contact": "Discover your ideal home at 51 at Southaven in Southaven, MS! Explore our spacious one, two, and three-bedroom floor plans designed for your comfort. Whether you're looking for a cozy retreat or a larger space, we have something for everyone. Have questions? Contact our leasing team today for personalized assistance!",
  "property_seo_title_faqs": "FAQs | Apartments in Southaven, MS",
  "property_seo_description_faqs": "Discover your ideal home at 51 at Southaven, located in the heart of Southaven, MS! Explore our diverse floor plans, featuring spacious one, two, and three-bedroom apartments with modern amenities. Enjoy residents' perks like a refreshing pool, a state-of-the-art fitness center, and a tranquil Zen garden. Our family-friendly community also offers a clubhouse, gameroom, and planned social activities for all ages. Have questions? Browse our FAQs page for answers on living in our vibrant community, designed to elevate your lifestyle. Join us today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Southaven, MS",
  "property_seo_description_reviews": "Discover the vibrant lifestyle at 51 at Southaven, where comfort meets convenience in the heart of Southaven, MS. Explore our thoughtfully designed one, two, and three-bedroom floor plans, complemented by an array of luxurious amenities including a refreshing pool, state-of-the-art fitness center, and relaxing Zen garden. Experience community living like never before with planned social activities, a clubhouse, and walking/biking trails. Curious about our residents’ experiences? See what our residents have to say about living at our community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Southaven, MS",
  "property_seo_description_applynow": "Discover your perfect home at **51 at Southaven**, where comfort meets convenience in Southaven, MS. Choose from our spacious one, two, and three-bedroom floor plans, and enjoy resort-style amenities including a sparkling pool, modern fitness center, and a vibrant clubhouse. Experience community living with planned social activities, on-site maintenance, and EV charging stations. Enjoy the tranquility of our Zen garden and stay connected with community-wide WiFi. Ready to make 51 at Southaven your new home? **Apply now and lease online today!**",
  "property_seo_title_residentaccess": "Resident Access | 51 at Southaven",
  "property_seo_description_residentaccess": "\"Welcome to 51 at Southaven! Access your resident portal now to effortlessly pay rent, schedule maintenance, and manage your apartment needs in Southaven, MS. Secure your peace of mind today!\"",
  "property_seo_title_referafriend": "Refer A Friend | 51 at Southaven",
  "property_seo_description_referafriend": "\"Discover the joy of living at 51 at Southaven! Refer a friend to our vibrant Southaven, MS apartment community and enjoy exclusive rewards. Great friends make great neighbors—spread the word and enhance your living experience today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | 51 at Southaven",
  "property_seo_description_scheduletour": "\"Discover your new home at 51 at Southaven! Experience comfortable living in Southaven, MS, with modern amenities and a welcoming community. Schedule a tour today and envision your future in our beautiful apartments!\"",
  "property_seo_title_privacy": "Privacy Policy | 51 at Southaven",
  "property_seo_description_privacy": "\"Discover peace of mind at 51 at Southaven in Southaven, MS. Our Privacy Policy ensures your information is protected while enjoying our vibrant apartment community. View our privacy policy now to learn how we safeguard your data.\"",
  "property_seo_title_accessibility": "Website Accessibility | 51 at Southaven",
  "property_seo_description_accessibility": "\"Discover our commitment to digital inclusion at 51 at Southaven. Explore our comprehensive accessibility statement and learn how we strive to create an inclusive community for all residents in Southaven, MS. Join us in fostering a welcoming environment today!\"",
  "property_seo_title_sitemap": "Sitemap | 51 at Southaven",
  "property_seo_description_sitemap": "\"Explore the convenient lifestyle at 51 at Southaven in Southaven, MS! Navigate our comprehensive sitemap to discover everything our vibrant apartment community has to offer. View now!\"",
  "property_seo_title_thankyou": "Thank You | 51 at Southaven",
  "property_seo_description_thankyou": "Thank you for your interest in 51 at Southaven! Your request has been received, and our dedicated team will be in touch soon. Discover your future home in the heart of Southaven, MS. Stay tuned for more information about our vibrant community and exceptional amenities!",
  "property_seo_title_pets": "Pet Policy | Apartments in Southaven, MS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293616983",
  "amenities": [
    {
      "id": "custom_0c40fd34-3f2d-427d-b11c-6d3a46e18638",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "2 Laundry Facilities",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_257c7942-2f76-4cc9-825e-142ec7ae6348",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "3 Shimmering Swimming Pools",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d283f67-0622-47ff-8dc1-7ddd76b1d1f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2b93d0ae-cd87-4115-95c4-626c0d2712a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_abc49d62-1f87-4247-b31e-2d1d761cde0a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3128cf8d-d33f-4b2c-bea2-1b4c154e65a2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Copy and Fax Services",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5569a403-dd49-481c-904d-eca2e655b6b3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b8cf4eff-42b6-4751-a017-74558a3bb90b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fc725095-ea63-4ea3-96f7-941688106238",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to Shopping and Dining",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c92b1bab-91bf-48be-b573-80dd25777fdc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "High‑speed Internet Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c17415d9-301b-4fc0-a3b8-75dfdad30aa2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dd8cde39-3c3b-4116-b9ac-90bf277668ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Picnic Area with Barbecue",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ac10b3f9-e3b8-4dca-9c2a-bfc1760058b2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c3195138-1822-4d64-9182-fec4b116191a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_85326a00-74ca-4fdb-8793-828a7ff7d180",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "State‑of‑the‑art Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eee03e29-2251-46c1-a5d1-fd81be89d791",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Breakfast Bar",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5c86a1da-43fd-4a99-aacd-4956e52d5dae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_03a7e337-7613-483f-969e-419e016674f1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d8cd8d79-bf1b-4f27-9225-45fe0164098e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0db45b5d-e9ae-4565-87a2-cfe867ca6153",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Extra Storage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d3f29c43-a979-439a-8564-53f5cadb1092",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Hard Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_092a2631-07e0-44e9-9e45-c3d56922293a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1efa6595-ca7a-4c2f-af0d-6877448090c8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceilings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_43c90ac4-5d41-4812-be45-eda8f330094b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑in Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_66ae9f51-a4e0-4e6b-8534-68839dba7d6c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer Connections*",
      "amount": "false",
      "description": "In select apartments.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_83f807d6-6eab-48fc-b383-055447277c4b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019fa438-c9b9-7432-b7c8-095ff38a9766.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables.",
        "public_id": "019fa438-c9b9-7432-b7c8-095ff38a9766",
        "storage_key": "property/6737460151192624/019fa438-c9b9-7432-b7c8-095ff38a9766.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing on sunny days.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9871be18-81fa-45b6-8d82-0f1e710626c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-5f3f-70cd-9920-23ad59f459ff.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with yellow lounge chairs and a black fence.",
        "public_id": "019e60b3-5f3f-70cd-9920-23ad59f459ff",
        "storage_key": "property/6737460151192624/019e60b3-5f3f-70cd-9920-23ad59f459ff.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs perfect for sunbathing.",
      "link": "",
      "alt_text": "Outdoor swimming pool with yellow lounge chairs and a black fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_665f4dd9-9f2c-46bc-8dce-df8fe906beef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019fa438-c442-70ee-9b60-faa5818b5077.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and tables.",
        "public_id": "019fa438-c442-70ee-9b60-faa5818b5077",
        "storage_key": "property/6737460151192624/019fa438-c442-70ee-9b60-faa5818b5077.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and tables for your enjoyment.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_035c6ef4-32af-4a7a-8f30-b10b510f6806",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b2-c1a9-71d9-a0fb-22c782b179c4.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with counter seating and a table with chairs.",
        "public_id": "019e60b2-c1a9-71d9-a0fb-22c782b179c4",
        "storage_key": "property/6737460151192624/019e60b2-c1a9-71d9-a0fb-22c782b179c4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a spacious dining area connected to your kitchen, perfect for entertaining guests.",
      "link": "",
      "alt_text": "Dining area and kitchen with counter seating and a table with chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bb4ed355-2160-48db-a768-ba1355067911",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-6a58-750b-9440-366cf98d986c.webp",
      "image_media": {
        "alt_text": "Conference room with large oval wooden table, blue chairs, and abstract art.",
        "public_id": "019e60b3-6a58-750b-9440-366cf98d986c",
        "storage_key": "property/6737460151192624/019e60b3-6a58-750b-9440-366cf98d986c.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Host your next meeting or collaborate with colleagues in our professional conference room, featuring a large table and comfortable seating.",
      "link": "",
      "alt_text": "Conference room with large oval wooden table, blue chairs, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c7c836ab-963c-495f-be95-b46a9aa43180",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-3d29-7383-9c50-862dec956d74.webp",
      "image_media": {
        "alt_text": "Bedroom with a desk and chair, a closet, and a painting of a dog.",
        "public_id": "019e60b3-3d29-7383-9c50-862dec956d74",
        "storage_key": "property/6737460151192624/019e60b3-3d29-7383-9c50-862dec956d74.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A bedroom featuring a workspace with a desk and chair, a spacious walk-in closet, and a unique painting that adds a touch of personality.",
      "link": "",
      "alt_text": "Bedroom with a desk and chair, a closet, and a painting of a dog.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4346f2d8-6c3d-4114-8434-c7543148d017",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-61fd-765b-94f4-1d5c3b7c75bd.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables.",
        "public_id": "019e60b3-61fd-765b-94f4-1d5c3b7c75bd",
        "storage_key": "property/6737460151192624/019e60b3-61fd-765b-94f4-1d5c3b7c75bd.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable seating areas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a94cea77-b521-4a62-86ec-defd6f06a31a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-5e3e-7168-8bef-0b477b2b7256.webp",
      "image_media": {
        "alt_text": "Community pool with lounge chairs and a fenced enclosure.",
        "public_id": "019e60b3-5e3e-7168-8bef-0b477b2b7256",
        "storage_key": "property/6737460151192624/019e60b3-5e3e-7168-8bef-0b477b2b7256.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax by the sparkling community pool, complete with comfortable lounge chairs and a fenced enclosure for your peace of mind.",
      "link": "",
      "alt_text": "Community pool with lounge chairs and a fenced enclosure.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fc1a520f-de00-45f4-a351-f3141c6bd033",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-6032-70c0-b982-3269fac58d9a.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a blue sky.",
        "public_id": "019e60b3-6032-70c0-b982-3269fac58d9a",
        "storage_key": "property/6737460151192624/019e60b3-6032-70c0-b982-3269fac58d9a.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs for soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e6bc1b06-9290-417c-9d3c-8f62027d18b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-4a76-71b9-b3bd-d6c0523a08f2.webp",
      "image_media": {
        "alt_text": "Living room with sofa and kitchen area with bar stools and view into bedroom.",
        "public_id": "019e60b3-4a76-71b9-b3bd-d6c0523a08f2",
        "storage_key": "property/6737460151192624/019e60b3-4a76-71b9-b3bd-d6c0523a08f2.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish living area with a modern sofa, coffee table, and adjoining kitchen with a breakfast bar and stools. A glimpse into the cozy bedroom completes this inviting apartment space.",
      "link": "",
      "alt_text": "Living room with sofa and kitchen area with bar stools and view into bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_23b1d8ef-dc6d-4839-bb02-0ecefeeee7a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b2-a103-7449-a2cf-c6c8fc39aa60.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower/tub combo with a patterned shower curtain.",
        "public_id": "019e60b2-a103-7449-a2cf-c6c8fc39aa60",
        "storage_key": "property/6737460151192624/019e60b2-a103-7449-a2cf-c6c8fc39aa60.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with a cultured marble countertop, a white toilet, and a shower/tub combination with a stylish geometric shower curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and shower/tub combo with a patterned shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d99f2a19-5045-47ab-9cda-731c48c10579",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-5f3f-70cd-9920-1d54058b1499.webp",
      "image_media": {
        "alt_text": "Swimming pool area with lounge chairs and an umbrella.",
        "public_id": "019e60b3-5f3f-70cd-9920-1d54058b1499",
        "storage_key": "property/6737460151192624/019e60b3-5f3f-70cd-9920-1d54058b1499.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and shaded by an umbrella. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Swimming pool area with lounge chairs and an umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ea6e78c0-b64e-4542-8028-4c232b6dad74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019fa438-c449-720a-b82e-a0a0f357d36d.webp",
      "image_media": {
        "alt_text": "Clubhouse business center with computers and desks.",
        "public_id": "019fa438-c449-720a-b82e-a0a0f357d36d",
        "storage_key": "property/6737460151192624/019fa438-c449-720a-b82e-a0a0f357d36d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Our clubhouse business center offers computers and desks for resident use.",
      "link": "",
      "alt_text": "Clubhouse business center with computers and desks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_57e6dd4d-bedc-4e79-a4db-79aa2c5f55fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019fa438-ca12-7481-adf6-8765134b5b33.webp",
      "image_media": {
        "alt_text": "Conference room with oval wooden table, blue chairs, and desk with computer.",
        "public_id": "019fa438-ca12-7481-adf6-8765134b5b33",
        "storage_key": "property/6737460151192624/019fa438-ca12-7481-adf6-8765134b5b33.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Conduct business or host meetings in our modern conference room, equipped with a large table, comfortable seating, and a convenient workspace.",
      "link": "",
      "alt_text": "Conference room with oval wooden table, blue chairs, and desk with computer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7ac893a0-9b57-498e-a554-0e6b87afa3f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-5b41-72e9-b3c9-f17b96edb2f7.webp",
      "image_media": {
        "alt_text": "Community room with tables and chairs and a kitchenette.",
        "public_id": "019e60b3-5b41-72e9-b3c9-f17b96edb2f7",
        "storage_key": "property/6737460151192624/019e60b3-5b41-72e9-b3c9-f17b96edb2f7.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in our spacious community room, featuring a convenient kitchenette and ample seating for all your social events.",
      "link": "",
      "alt_text": "Community room with tables and chairs and a kitchenette.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b2031cc5-d020-4f48-b3b2-7c077926608b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-61a5-7153-9e31-48542f60662a.webp",
      "image_media": {
        "alt_text": "Community room with tables, chairs, and a kitchenette.",
        "public_id": "019e60b3-61a5-7153-9e31-48542f60662a",
        "storage_key": "property/6737460151192624/019e60b3-61a5-7153-9e31-48542f60662a.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in the community room, featuring a kitchenette and ample seating for social events or casual get-togethers.",
      "link": "",
      "alt_text": "Community room with tables, chairs, and a kitchenette.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6802da50-0883-403b-a045-e4028f6a3325",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-5853-7759-881c-d88657b471c5.webp",
      "image_media": {
        "alt_text": "Picnic tables and benches on concrete patio with apartment buildings in background.",
        "public_id": "019e60b3-5853-7759-881c-d88657b471c5",
        "storage_key": "property/6737460151192624/019e60b3-5853-7759-881c-d88657b471c5.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with friends and family at our community picnic area, complete with tables and grills.",
      "link": "",
      "alt_text": "Picnic tables and benches on concrete patio with apartment buildings in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_70314a79-f9f1-4919-b882-4bda699a96fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-5c3d-7002-8df9-2be554e41e9d.webp",
      "image_media": {
        "alt_text": "Signage for 51 Southaven at Apartment Homes.",
        "public_id": "019e60b3-5c3d-7002-8df9-2be554e41e9d",
        "storage_key": "property/6737460151192624/019e60b3-5c3d-7002-8df9-2be554e41e9d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Welcome to 51 Southaven at Apartment Homes. Discover a vibrant community with lush landscaping and elegant exterior architecture.",
      "link": "",
      "alt_text": "Signage for 51 Southaven at Apartment Homes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5e924b76-d96a-4c01-abb5-775bd6ea3256",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019fa438-c461-73bc-a418-5f946d4e311e.webp",
      "image_media": {
        "alt_text": "Leasing office entrance with a pathway and signage.",
        "public_id": "019fa438-c461-73bc-a418-5f946d4e311e",
        "storage_key": "property/6737460151192624/019fa438-c461-73bc-a418-5f946d4e311e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Welcome to the leasing office at 51 Southaven, where our friendly team is ready to assist you with finding your perfect home.",
      "link": "",
      "alt_text": "Leasing office entrance with a pathway and signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a206b50a-c6b5-448b-a668-95edf70f33ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-5390-741e-80bf-a5ebd3aadde9.webp",
      "image_media": {
        "alt_text": "Outdoor picnic area with picnic tables and benches",
        "public_id": "019e60b3-5390-741e-80bf-a5ebd3aadde9",
        "storage_key": "property/6737460151192624/019e60b3-5390-741e-80bf-a5ebd3aadde9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings at our community picnic area, complete with tables, benches, and grilling stations.",
      "link": "",
      "alt_text": "Outdoor picnic area with picnic tables and benches",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c83a9946-9648-45e9-8bcc-c4ad8b46434e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-5282-731a-8724-88b0e8e5f2ac.webp",
      "image_media": {
        "alt_text": "Dog park area with green tunnel, agility equipment, and benches within a fenced-in yard.",
        "public_id": "019e60b3-5282-731a-8724-88b0e8e5f2ac",
        "storage_key": "property/6737460151192624/019e60b3-5282-731a-8724-88b0e8e5f2ac.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Our pet-friendly community features a dedicated dog park for your furry friends to play and exercise.",
      "link": "",
      "alt_text": "Dog park area with green tunnel, agility equipment, and benches within a fenced-in yard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3db4ce20-0fa9-456c-b646-707134766c0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-513e-7263-885e-554b47b5e1da.webp",
      "image_media": {
        "alt_text": "Dog park agility equipment including a tunnel, ramp, and dog-shaped statues.",
        "public_id": "019e60b3-513e-7263-885e-554b47b5e1da",
        "storage_key": "property/6737460151192624/019e60b3-513e-7263-885e-554b47b5e1da.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility equipment for your furry friends to play and exercise.",
      "link": "",
      "alt_text": "Dog park agility equipment including a tunnel, ramp, and dog-shaped statues.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1bf5e499-f786-4a5f-903c-0f655148aba6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-518f-7010-a1c1-2e89c2dd38ad.webp",
      "image_media": {
        "alt_text": "Outdoor picnic area with grill and picnic tables at apartment complex.",
        "public_id": "019e60b3-518f-7010-a1c1-2e89c2dd38ad",
        "storage_key": "property/6737460151192624/019e60b3-518f-7010-a1c1-2e89c2dd38ad.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy the outdoors at our community picnic area, complete with grills and ample seating for gatherings.",
      "link": "",
      "alt_text": "Outdoor picnic area with grill and picnic tables at apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_353af687-0fa3-4462-9109-551d6ba9d839",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-506e-70c8-a815-ab583e679c9f.webp",
      "image_media": {
        "alt_text": "Picnic tables and grills are set up on a concrete patio area outside apartment buildings.",
        "public_id": "019e60b3-506e-70c8-a815-ab583e679c9f",
        "storage_key": "property/6737460151192624/019e60b3-506e-70c8-a815-ab583e679c9f.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and grilling at our community picnic areas, perfect for gathering with friends and family.",
      "link": "",
      "alt_text": "Picnic tables and grills are set up on a concrete patio area outside apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d36a5c7e-1fe4-48ee-86ca-7ebc8ffcc50f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-4e1f-701a-b968-e7fba30b0605.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with modern sofa, coffee table, rug, bar stools, and cabinets.",
        "public_id": "019e60b3-4e1f-701a-b968-e7fba30b0605",
        "storage_key": "property/6737460151192624/019e60b3-4e1f-701a-b968-e7fba30b0605.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living area with a modern sofa and coffee table, opening to a kitchen with bar seating. Perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area with modern sofa, coffee table, rug, bar stools, and cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_42e18232-d7d8-4bf1-b329-8691ecfaab8b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-36c6-7537-966b-f3228682de0a.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a view of the bathroom.",
        "public_id": "019e60b3-36c6-7537-966b-f3228682de0a",
        "storage_key": "property/6737460151192624/019e60b3-36c6-7537-966b-f3228682de0a.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our spacious bedrooms, featuring plush carpeting and elegant decor. Step into your private ensuite bathroom for added convenience.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, and a view of the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8b3bc5b1-45a1-4cb5-bb05-23fc4ef87e4e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-418b-744a-83f5-91c42d42f159.webp",
      "image_media": {
        "alt_text": "Living room with grey sofa, coffee table, and rug. Bedroom visible through doorway.",
        "public_id": "019e60b3-418b-744a-83f5-91c42d42f159",
        "storage_key": "property/6737460151192624/019e60b3-418b-744a-83f5-91c42d42f159.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable grey sofa, modern coffee table, and a decorative rug. A glimpse into the bedroom offers a complete view of the apartment's interior design.",
      "link": "",
      "alt_text": "Living room with grey sofa, coffee table, and rug. Bedroom visible through doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c28ca484-d78c-4e84-aee6-4ac6e04f048a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-3de1-7206-87cb-2b8283f98321.webp",
      "image_media": {
        "alt_text": "Kitchen with dual basin sink, faucet, dishwasher, and breakfast bar overlooking living area.",
        "public_id": "019e60b3-3de1-7206-87cb-2b8283f98321",
        "storage_key": "property/6737460151192624/019e60b3-3de1-7206-87cb-2b8283f98321.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a dual basin sink and breakfast bar, opening up to a well-lit living space.",
      "link": "",
      "alt_text": "Kitchen with dual basin sink, faucet, dishwasher, and breakfast bar overlooking living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cdca86e5-8aec-47b8-8adb-24a3a253f236",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-3f67-71fd-acc4-351a63ac6701.webp",
      "image_media": {
        "alt_text": "Kitchen island with bar stools and adjacent dining area with a table and chairs.",
        "public_id": "019e60b3-3f67-71fd-acc4-351a63ac6701",
        "storage_key": "property/6737460151192624/019e60b3-3f67-71fd-acc4-351a63ac6701.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Modern kitchen and dining area featuring a breakfast bar with bar stools, a dining table with chairs, and elegant decor.",
      "link": "",
      "alt_text": "Kitchen island with bar stools and adjacent dining area with a table and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_09e266ee-854f-496d-b951-2f804e077853",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-3dc1-7638-9196-7fd65c34837d.webp",
      "image_media": {
        "alt_text": "Dining area with a small wooden table, four metal chairs, a large floral painting, and a bottle of wine.",
        "public_id": "019e60b3-3dc1-7638-9196-7fd65c34837d",
        "storage_key": "property/6737460151192624/019e60b3-3dc1-7638-9196-7fd65c34837d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish dining area featuring a modern wooden table, sleek metal chairs, and decorative art, perfect for intimate meals.",
      "link": "",
      "alt_text": "Dining area with a small wooden table, four metal chairs, a large floral painting, and a bottle of wine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9c32848b-0b4e-40b5-9c4e-a0b4a26d344a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-38b3-763d-b5b3-23a490ff5f1d.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower",
        "public_id": "019e60b3-38b3-763d-b5b3-23a490ff5f1d",
        "storage_key": "property/6737460151192624/019e60b3-38b3-763d-b5b3-23a490ff5f1d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with a sink, a toilet, and a shower with a decorative curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and shower",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b9ba0940-0437-4a10-b85a-081f9e3017b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-4094-77a3-b85a-d445960470c2.webp",
      "image_media": {
        "alt_text": "Community business center with workstations, computers, printer, and decorative wall art.",
        "public_id": "019e60b3-4094-77a3-b85a-d445960470c2",
        "storage_key": "property/6737460151192624/019e60b3-4094-77a3-b85a-d445960470c2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay productive in our community business center, equipped with workstations, computers, and a printer for resident use. Decorated with fun, retro-themed art.",
      "link": "",
      "alt_text": "Community business center with workstations, computers, printer, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1b763eba-2720-4642-b8d2-20541e18a2f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-63a4-7201-ae26-df91fbeff7c3.webp",
      "image_media": {
        "alt_text": "Modern leasing office reception area with a large desk, comfortable seating, and artwork.",
        "public_id": "019e60b3-63a4-7201-ae26-df91fbeff7c3",
        "storage_key": "property/6737460151192624/019e60b3-63a4-7201-ae26-df91fbeff7c3.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Welcome to our modern leasing office. Experience comfort and efficiency in our beautifully designed reception area, perfect for all your leasing needs.",
      "link": "",
      "alt_text": "Modern leasing office reception area with a large desk, comfortable seating, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4d5eb76f-0acb-414d-8e92-0d89a456e63c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-3e5d-73fd-98c2-f2fcc436ae32.webp",
      "image_media": {
        "alt_text": "Kitchen with double sink, black refrigerator, and black electric stove with wooden cabinets.",
        "public_id": "019e60b3-3e5d-73fd-98c2-f2fcc436ae32",
        "storage_key": "property/6737460151192624/019e60b3-3e5d-73fd-98c2-f2fcc436ae32.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A spacious kitchen featuring a double sink, black refrigerator, and black electric stove, complemented by warm wooden cabinets.",
      "link": "",
      "alt_text": "Kitchen with double sink, black refrigerator, and black electric stove with wooden cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_493c856d-8072-4b3e-9dbd-e37632f16324",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-1a80-72e7-8307-81a126166a5f.webp",
      "image_media": {
        "alt_text": "Community room with tables and chairs, featuring a kitchenette area.",
        "public_id": "019e60b3-1a80-72e7-8307-81a126166a5f",
        "storage_key": "property/6737460151192624/019e60b3-1a80-72e7-8307-81a126166a5f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gather with neighbors in this comfortable community room, complete with a convenient kitchenette for your events.",
      "link": "",
      "alt_text": "Community room with tables and chairs, featuring a kitchenette area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ac2845b2-e707-49e0-99a7-29c7629cc31e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-2855-736a-81b4-c020fe4875c3.webp",
      "image_media": {
        "alt_text": "Bathroom with sink, toilet, and shower with gray patterned curtains.",
        "public_id": "019e60b3-2855-736a-81b4-c020fe4875c3",
        "storage_key": "property/6737460151192624/019e60b3-2855-736a-81b4-c020fe4875c3.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with a sink, a toilet, and a shower/tub combo with a decorative gray patterned shower curtain.",
      "link": "",
      "alt_text": "Bathroom with sink, toilet, and shower with gray patterned curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6f64683d-eef8-41e8-a5c7-a91d7f31458c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-16b3-73b8-a6ee-60401a0d4c3c.webp",
      "image_media": {
        "alt_text": "King size bed with striped comforter and pillows, nightstand with lamp, and doorway to bathroom and closet.",
        "public_id": "019e60b3-16b3-73b8-a6ee-60401a0d4c3c",
        "storage_key": "property/6737460151192624/019e60b3-16b3-73b8-a6ee-60401a0d4c3c.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a king size bed with a plush striped comforter, a stylish nightstand with a lamp, and convenient access to a bathroom and spacious closet.",
      "link": "",
      "alt_text": "King size bed with striped comforter and pillows, nightstand with lamp, and doorway to bathroom and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_222a13dd-b6b4-4522-902a-d9563a2e928b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b3-128f-700d-a08f-3d5d72ff68ce.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed and view into the bathroom and a closet.",
        "public_id": "019e60b3-128f-700d-a08f-3d5d72ff68ce",
        "storage_key": "property/6737460151192624/019e60b3-128f-700d-a08f-3d5d72ff68ce.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a plush bed, a bedside lamp, and a view of the ensuite bathroom and closet. This space offers comfort and convenience.",
      "link": "",
      "alt_text": "Bedroom with a large bed and view into the bathroom and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dd7a411e-e736-4dbd-8597-40b2fb02e4c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b2-dce1-733e-8c78-1e78a87082db.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, and kitchen bar with stools.",
        "public_id": "019e60b2-dce1-733e-8c78-1e78a87082db",
        "storage_key": "property/6737460151192624/019e60b2-dce1-733e-8c78-1e78a87082db.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sofa, modern coffee table, and an open-concept kitchen with a breakfast bar. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with sofa, coffee table, and kitchen bar with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_48f2cb5b-caa5-4f45-9dc1-d41e31c5a807",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e60b2-dc82-762c-a773-7d93bc707b7b.webp",
      "image_media": {
        "alt_text": "Living room with gray sofa, coffee table, and rug, leading into a bedroom with a bed.",
        "public_id": "019e60b2-dc82-762c-a773-7d93bc707b7b",
        "storage_key": "property/6737460151192624/019e60b2-dc82-762c-a773-7d93bc707b7b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room with a sofa and coffee table, adjacent to a well-appointed bedroom.",
      "link": "",
      "alt_text": "Living room with gray sofa, coffee table, and rug, leading into a bedroom with a bed.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_54710831-c979-447e-8235-a90009a3be5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019fa438-c963-70fb-a902-c9eae6d7fe30.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrella.",
        "public_id": "019fa438-c963-70fb-a902-c9eae6d7fe30",
        "storage_key": "property/6737460151192624/019fa438-c963-70fb-a902-c9eae6d7fe30.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, featuring comfortable lounge chairs and ample space to soak up the sun.",
      "link": "",
      "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d790c729-0020-4134-8f9a-c49f40a3b807",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019fa438-c438-726e-87c3-51f7bbb4b805.webp",
      "image_media": {
        "alt_text": "Swimming pool with yellow lounge chairs and buildings in the background.",
        "public_id": "019fa438-c438-726e-87c3-51f7bbb4b805",
        "storage_key": "property/6737460151192624/019fa438-c438-726e-87c3-51f7bbb4b805.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, surrounded by comfortable lounge chairs and a well-maintained courtyard. A perfect spot for a sunny day.",
      "link": "",
      "alt_text": "Swimming pool with yellow lounge chairs and buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ebeee6d3-2a50-4f4d-a0f0-c44a0a998d28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019fa438-c9c6-72b8-9b1c-10e2108ff623.webp",
      "image_media": {
        "alt_text": "A common area dining table with chairs and a desk with a computer.",
        "public_id": "019fa438-c9c6-72b8-9b1c-10e2108ff623",
        "storage_key": "property/6737460151192624/019fa438-c9c6-72b8-9b1c-10e2108ff623.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a shared dining experience or get some work done in this versatile common area, featuring a large table and a convenient workspace.",
      "link": "",
      "alt_text": "A common area dining table with chairs and a desk with a computer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_63c5732d-05b9-4b15-8609-ca5ed32a0bf9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019fa438-c9c4-707c-b942-9c8a8b1b5111.webp",
      "image_media": {
        "alt_text": "A spacious community area with desks and seating.",
        "public_id": "019fa438-c9c4-707c-b942-9c8a8b1b5111",
        "storage_key": "property/6737460151192624/019fa438-c9c4-707c-b942-9c8a8b1b5111.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Welcome to our vibrant community spaces, featuring comfortable seating and workstations for your convenience.",
      "link": "",
      "alt_text": "A spacious community area with desks and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_899564c2-edaa-4bfd-bfe9-ed46e77c2479",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019fa438-c9cd-71bc-ae0c-2352b307fed5.webp",
      "image_media": {
        "alt_text": "Business center with two workstations, a printer, and retro-themed artwork.",
        "public_id": "019fa438-c9cd-71bc-ae0c-2352b307fed5",
        "storage_key": "property/6737460151192624/019fa438-c9cd-71bc-ae0c-2352b307fed5.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay connected and productive in our resident business center, complete with workstations, a printer, and inspiring decor.",
      "link": "",
      "alt_text": "Business center with two workstations, a printer, and retro-themed artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_d14f8fef-7396-4e65-8462-cef58f335006",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "7125 Desoto Cove, Horn Lake, MS 38637, USA",
      "poi_short_description": "Chain steakhouse with an Old West theme offering steaks, ribs, burgers and bread rolls with cinnamon butter.",
      "poi_long_description": "Diners say this steak house serves delicious rolls with cinnamon butter, and many recommend the catfish and steaks. They also highlight the friendly and attentive service, reasonable prices, and plentiful portions.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-d6c4-76ce-89b1-d6c210ad85dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-d6c4-76ce-89b1-d6c210ad85dd",
        "storage_key": "property/6737460151192624/019d0783-d6c4-76ce-89b1-d6c210ad85dd.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/mississippi/horn-lake?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=17826613085369479167&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "34.964458",
      "poi_longitude": "-90.00239189999999",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 662-536-4044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-16e2-75ca-b196-4c5dcfda71b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-16e2-75ca-b196-4c5dcfda71b9",
        "storage_key": "property/6737460151192624/019d0784-16e2-75ca-b196-4c5dcfda71b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvTIS8wli1YcR_y_H1SbaZPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_b6507882-f276-4a90-b4dd-69732b99e578",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Memphis Barbecue Company",
      "poi_type": "Restaurants",
      "poi_address": "709 Desoto Cove, Horn Lake, MS 38637, USA",
      "poi_short_description": "Casual BBQ chain with a sports bar-like setting, serving dishes like ribs and brisket and smoked meats, plus beer and cocktails.",
      "poi_long_description": "People say this barbecue restaurant serves delicious ribs, pulled pork, and burnt ends. They also highlight the generous portions, the tasty pork rinds, and the friendly staff.\n\nSome reviews mention the brisket can be dry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-d79f-739d-b407-6b81285d2668.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-d79f-739d-b407-6b81285d2668",
        "storage_key": "property/6737460151192624/019d0783-d79f-739d-b407-6b81285d2668.webp",
        "width": 1280,
        "height": 944
      },
      "poi_business_url": "http://memphisbbqco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4953449014370613864&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "memphis-barbecue-company",
      "poi_latitude": "34.9631775",
      "poi_longitude": "-90.00238739999999",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 662-536-3762",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-16e2-75ca-b196-4c5dcfda71b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-16e2-75ca-b196-4c5dcfda71b9",
        "storage_key": "property/6737460151192624/019d0784-16e2-75ca-b196-4c5dcfda71b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Qf92ghi1YcRaLqRUqIvvkQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_97675ce0-450f-4367-8489-5dc2f9c91774",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "357 Goodman Rd W, Southaven, MS 38671, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken tenders, buttery toast, and good slaw. They also highlight the fast service, friendly staff, and great sauce.\n\nOther reviews mention the chicken tenders can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-d6a8-7069-a738-4296a2666770.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-d6a8-7069-a738-4296a2666770",
        "storage_key": "property/6737460151192624/019d0783-d6a8-7069-a738-4296a2666770.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.raisingcanes.com/ms/southaven/357-goodman-road-w",
      "poi_directions_map_url": "https://maps.google.com/?cid=15938962671474676032&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "34.96188",
      "poi_longitude": "-89.99683979999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 662-205-3175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-16e2-75ca-b196-4c5dcfda71b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-16e2-75ca-b196-4c5dcfda71b9",
        "storage_key": "property/6737460151192624/019d0784-16e2-75ca-b196-4c5dcfda71b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-4gBAwCJf4gRQJF1-RmSMt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_7fed4e6a-57fc-4fa8-bac7-b7ed32c14f4b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "235 Goodman Rd W, Southaven, MS 38671, USA",
      "poi_short_description": "Familiar restaurant chain featuring chicken sandwiches and nuggets breakfast (served until 10:30am), salads and tasty lemonades.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches and crispy waffle fries. They highlight the affordable prices and quick service. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-d77a-7763-9278-edf548f351e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-d77a-7763-9278-edf548f351e3",
        "storage_key": "property/6737460151192624/019d0783-d77a-7763-9278-edf548f351e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ms/southaven?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=7880743532791415562&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "34.96208",
      "poi_longitude": "-89.99407029999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 662-349-3587",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-16e2-75ca-b196-4c5dcfda71b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-16e2-75ca-b196-4c5dcfda71b9",
        "storage_key": "property/6737460151192624/019d0784-16e2-75ca-b196-4c5dcfda71b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEUiIuOSJf4gRCkP9NX0GXm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_fa31a88a-c75f-4df4-b740-b34b3e956722",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Georgia Blue",
      "poi_type": "Restaurants",
      "poi_address": "6389 Getwell Rd, Southaven, MS 38672, USA",
      "poi_short_description": "Casual restaurant serving familiar fare such as shrimp and grits, plus cocktails, and live music.",
      "poi_long_description": "People say this restaurant serves delicious turnip green bites, fried green tomatoes, and shrimp and grits. They also highlight the attentive service, friendly staff, and fun atmosphere with live music and karaoke.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-dd5b-7689-b044-da01f8a71bb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-dd5b-7689-b044-da01f8a71bb9",
        "storage_key": "property/6737460151192624/019d0783-dd5b-7689-b044-da01f8a71bb9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://georgiablue.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1955659738787512258&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "georgia-blue",
      "poi_latitude": "34.953543",
      "poi_longitude": "-89.9373899",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 662-612-2583",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-16e2-75ca-b196-4c5dcfda71b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-16e2-75ca-b196-4c5dcfda71b9",
        "storage_key": "property/6737460151192624/019d0784-16e2-75ca-b196-4c5dcfda71b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Z3aP8CJf4gRwn_2vyvmIxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5b2acdea-dde5-4e23-99d0-e8086979ae0b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Tanger Outlets Southaven",
      "poi_type": "Shopping & Retail",
      "poi_address": "5205 Airways Blvd, Southaven, MS 38671, USA",
      "poi_short_description": "Open-air facility housing well-known retailers specializing in apparel, shoes and housewares.",
      "poi_long_description": "Shoppers say this outlet mall offers a wide variety of stores with great deals on popular brands, including shoes and clothes. They also highlight the friendly and helpful staff, the clean and well-maintained environment, and the convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-dd6a-72ad-9b9d-0cce9706590e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-dd6a-72ad-9b9d-0cce9706590e",
        "storage_key": "property/6737460151192624/019d0783-dd6a-72ad-9b9d-0cce9706590e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tangeroutlet.com/southaven",
      "poi_directions_map_url": "https://maps.google.com/?cid=4680283497031334424&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "tanger-outlets-southaven",
      "poi_latitude": "34.93625550000001",
      "poi_longitude": "-89.9916172",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 662-349-1701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-16e1-7028-96eb-7afb7eba3e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-16e1-7028-96eb-7afb7eba3e1a",
        "storage_key": "property/6737460151192624/019d0784-16e1-7028-96eb-7afb7eba3e1a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJX_MnNw6Kf4gRGPqsGAu180A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_229dfddf-8ca2-424b-8e3f-e88986824524",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Nike Clearance Store - Memphis",
      "poi_type": "Shopping & Retail",
      "poi_address": "4099 S Plaza Dr, Memphis, TN 38116, USA",
      "poi_short_description": "Chain retailer offering apparel and shoes for men, women, and children in South Plaza.",
      "poi_long_description": "People say this sportswear store offers a wide variety of Nike apparel and shoes at discounted prices, with many mentioning the great deals and selection. They also highlight the clean and well-organized space, and friendly and helpful staff.\n\nSome reviews mention the prices can be inconsistent with the marked tags.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-de35-727c-9ed7-f125d2b94af9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-de35-727c-9ed7-f125d2b94af9",
        "storage_key": "property/6737460151192624/019d0783-de35-727c-9ed7-f125d2b94af9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nike.com/retail/s/nike-clearance-store-memphis?cp=84620811901_seo_%3Fcp%3D84620811901_seo_&y_source=1_NTQzNzM0Ny03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5870741703000527974&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "nike-clearance-store---memphis",
      "poi_latitude": "35.036544",
      "poi_longitude": "-90.027794",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 901-332-9325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-16e1-7028-96eb-7afb7eba3e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-16e1-7028-96eb-7afb7eba3e1a",
        "storage_key": "property/6737460151192624/019d0784-16e1-7028-96eb-7afb7eba3e1a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJY3yXDM1i1YcRZhRrb3kQeVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_3c0bc113-26a2-4db7-ac9b-be3594426191",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "7260 Interstate Blvd, Horn Lake, MS 38637, USA",
      "poi_short_description": "Home-improvement, gardening and appliance store featuring outdoor patio furniture and BBQ grills.",
      "poi_long_description": "People say this home improvement store has helpful staff who can quickly find the items you need. They also highlight the wide selection of products and services, including appliance deliveries and tool rentals.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-de67-74fa-92b4-c22a298e9c39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-de67-74fa-92b4-c22a298e9c39",
        "storage_key": "property/6737460151192624/019d0783-de67-74fa-92b4-c22a298e9c39.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Southaven/MS/Horn-Lake/38637/2903?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10875214836919973795&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "34.9658227",
      "poi_longitude": "-90.0025867",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 662-349-6080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-16e1-7028-96eb-7afb7eba3e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-16e1-7028-96eb-7afb7eba3e1a",
        "storage_key": "property/6737460151192624/019d0784-16e1-7028-96eb-7afb7eba3e1a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGXOyJwli1YcRozesWkaG7JY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_4741eda7-f9ae-46ac-80e3-908151605c3e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "3095 Goodman Rd E, Southaven, MS 38672, USA",
      "poi_short_description": "Chain grocery outlet providing organic products and prepared foods, plus a salad bar.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-e331-768d-b11a-3b31934cd6f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-e331-768d-b11a-3b31934cd6f8",
        "storage_key": "property/6737460151192624/019d0783-e331-768d-b11a-3b31934cd6f8.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ms/southaven/goodman-getwell/025/00464?cid=loc_02500464_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17161598680288196851&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "34.9608134",
      "poi_longitude": "-89.9346238",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 662-536-3741",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-16eb-75fc-a29a-84932800352f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-16eb-75fc-a29a-84932800352f",
        "storage_key": "property/6737460151192624/019d0784-16eb-75fc-a29a-84932800352f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO5HnWUWJf4gR8_hj3BI_Ku4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_509d981c-4492-4800-a9bf-4e6c7cf1e9fb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Burlington",
      "poi_type": "Shopping & Retail",
      "poi_address": "225 Goodman Rd W, Southaven, MS 38671, USA",
      "poi_short_description": "Popular retailer of discount clothing, shoes and home goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-e393-73bc-a717-d6dca7e5408d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-e393-73bc-a717-d6dca7e5408d",
        "storage_key": "property/6737460151192624/019d0783-e393-73bc-a717-d6dca7e5408d.webp",
        "width": 488,
        "height": 289
      },
      "poi_business_url": "https://stores.burlington.com/ms/southaven/536/?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=18391311391153746058&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "burlington",
      "poi_latitude": "34.9600753",
      "poi_longitude": "-89.9933013",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 662-349-2795",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-16e1-7028-96eb-7afb7eba3e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-16e1-7028-96eb-7afb7eba3e1a",
        "storage_key": "property/6737460151192624/019d0784-16e1-7028-96eb-7afb7eba3e1a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfetRAPKJf4gRinBQ10QQO_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_bc3d830b-0318-4467-bf0c-a14c109a2a50",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Northwest Mississippi Community College - Desoto Center",
      "poi_type": "Education",
      "poi_address": "Desoto Center, 1210 Church Rd W, Southaven, MS 38671, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-e3dd-7066-94bd-375de297cc22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-e3dd-7066-94bd-375de297cc22",
        "storage_key": "property/6737460151192624/019d0783-e3dd-7066-94bd-375de297cc22.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.northwestms.edu/about/campuses/desoto-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9219461661712679333&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "northwest-mississippi-community-college---desoto-center",
      "poi_latitude": "34.9336211",
      "poi_longitude": "-90.0110502",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 662-342-1570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-16dd-7348-954f-aa1a60330392.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-16dd-7348-954f-aa1a60330392",
        "storage_key": "property/6737460151192624/019d0784-16dd-7348-954f-aa1a60330392.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs3YdEO9h1YcRpYG31ogb8n8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_07a0fa95-b323-4399-a15a-8595ae8a6bb5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Delta Technical College",
      "poi_type": "Education",
      "poi_address": "6530 Interstate Blvd, Horn Lake, MS 38637, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-e43c-740d-82f1-b67e8c6f9860.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-e43c-740d-82f1-b67e8c6f9860",
        "storage_key": "property/6737460151192624/019d0783-e43c-740d-82f1-b67e8c6f9860.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.deltatechnicalcollege.com/campuses/horn-lake-mississippi/?utm_source=google-local&utm_medium=organic&utm_campaign=local-seo",
      "poi_directions_map_url": "https://maps.google.com/?cid=8143307658239458691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "delta-technical-college",
      "poi_latitude": "34.9554365",
      "poi_longitude": "-89.9992171",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 662-280-1443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-16dd-7348-954f-aa1a60330392.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-16dd-7348-954f-aa1a60330392",
        "storage_key": "property/6737460151192624/019d0784-16dd-7348-954f-aa1a60330392.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo7BHtANi1YcRg70UiivXAnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_977816e0-0023-47fa-a651-a89d58ad936b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Graceland",
      "poi_type": "Entertainment",
      "poi_address": "Elvis Presley Blvd, Memphis, TN 38116, USA",
      "poi_short_description": "Lavish house of the King of Rock ‘n’ Roll, Elvis Presley, showcasing his cars, planes and costumes.",
      "poi_long_description": "Elvis Presley's famed estate featuring mansion tours, exhibits, a car museum & 2 jets.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-e98f-74c1-bd9f-ec815a82e023.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-e98f-74c1-bd9f-ec815a82e023",
        "storage_key": "property/6737460151192624/019d0783-e98f-74c1-bd9f-ec815a82e023.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.graceland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18251103567641561873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "graceland",
      "poi_latitude": "35.0476912",
      "poi_longitude": "-90.02604930000001",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 901-332-3322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b5f-72ff-ae3d-d5d007d2bf72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b5f-72ff-ae3d-d5d007d2bf72",
        "storage_key": "property/6737460151192624/019d0784-1b5f-72ff-ae3d-d5d007d2bf72.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJJXK9zjF91YcREcsjDP_xSP0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e9f1732d-25b8-42e2-89cd-78406359ddda",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "6680 Southcrest Pkwy, Southaven, MS 38671, USA",
      "poi_short_description": "Kid-friendly amusement park known for trampolines, obstacle courses and bumper cars, plus food and concessions.",
      "poi_long_description": "People say this amusement park offers a variety of attractions, including trampolines, a playground, and a ball pit, suitable for children of different ages.\n\nOther reviews mention the attractions can be broken and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-e9bc-72a6-b91f-f261b9a6de05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-e9bc-72a6-b91f-f261b9a6de05",
        "storage_key": "property/6737460151192624/019d0783-e9bc-72a6-b91f-f261b9a6de05.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/mississippi-southaven/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=16810823820183299286&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "34.9579409",
      "poi_longitude": "-89.9940179",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 662-351-2141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b69-75ae-8831-55656b4ec903",
        "storage_key": "property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi326fYSJf4gR1mSzZzILTOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_1de1858b-a298-4dc0-85d1-e82537ddaee9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Elvis Presley’s Memphis Museum",
      "poi_type": "Entertainment",
      "poi_address": "3797 Elvis Presley Blvd, Memphis, TN 38116, USA",
      "poi_short_description": "Museum showcasing a variety of artifacts, memorabilia and displays related to the King of Rock 'n' Roll: his cars (including Cadillacs) and outfits especially.",
      "poi_long_description": "People say this museum offers a tour of the home and other areas of the property, and showcases cars, outfits, and family photos. They highlight the informative tour, the use of headsets and tablets, and the convenient shuttle service. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-e9d4-715b-ac47-6f5f209d026f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-e9d4-715b-ac47-6f5f209d026f",
        "storage_key": "property/6737460151192624/019d0783-e9d4-715b-ac47-6f5f209d026f.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.graceland.com/epm",
      "poi_directions_map_url": "https://maps.google.com/?cid=10035773011178554940&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "elvis-presleys-memphis-museum",
      "poi_latitude": "35.0450748",
      "poi_longitude": "-90.0269592",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-238-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b5f-72ff-ae3d-d5d007d2bf72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b5f-72ff-ae3d-d5d007d2bf72",
        "storage_key": "property/6737460151192624/019d0784-1b5f-72ff-ae3d-d5d007d2bf72.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJn58meDF91YcRPAbAwWE6Ros",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_cc72a880-a31a-4edf-9fa6-f68786843fc3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Elvis Presley Automobile Museum",
      "poi_type": "Entertainment",
      "poi_address": "3717 Elvis Presley Blvd, Memphis, TN 38116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-ea72-7179-b02c-143eaa8438a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-ea72-7179-b02c-143eaa8438a5",
        "storage_key": "property/6737460151192624/019d0783-ea72-7179-b02c-143eaa8438a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.graceland.com/epm",
      "poi_directions_map_url": "https://maps.google.com/?cid=1656608335262391539&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "elvis-presley-automobile-museum",
      "poi_latitude": "35.04515120000001",
      "poi_longitude": "-90.0269306",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 901-332-3322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b5f-72ff-ae3d-d5d007d2bf72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b5f-72ff-ae3d-d5d007d2bf72",
        "storage_key": "property/6737460151192624/019d0784-1b5f-72ff-ae3d-d5d007d2bf72.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJIcQfrNh91YcR8xxE-4B0_RY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_9deeab97-76b8-470c-ac7e-f67fec9c5c8f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Tiger Stadium",
      "poi_type": "Entertainment",
      "poi_address": "4851 Elvis Presley Blvd, Memphis, TN 38116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-ef67-7319-958c-8e4bfce8086b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-ef67-7319-958c-8e4bfce8086b",
        "storage_key": "property/6737460151192624/019d0783-ef67-7319-958c-8e4bfce8086b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stadiumconnection.com/tn/stadium.php?id=5029",
      "poi_directions_map_url": "https://maps.google.com/?cid=7873462495440440755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "tiger-stadium",
      "poi_latitude": "35.0152808",
      "poi_longitude": "-90.0302071",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1c9a-757d-8fac-f8531f082669.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1c9a-757d-8fac-f8531f082669",
        "storage_key": "property/6737460151192624/019d0784-1c9a-757d-8fac-f8531f082669.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJafhE2OBj1YcRs40WmWwoRG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_1f2e55b6-3efe-4b93-8e0f-2be629090ad1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "DAC Southaven",
      "poi_type": "Health and Wellness",
      "poi_address": "3146 Goodman Rd E, Southaven, MS 38672, USA",
      "poi_short_description": "Sprawling gym featuring 2 pools, group and personal training, plus childcare options.",
      "poi_long_description": "People say this fitness center offers updated equipment and top-notch personal trainers. They highlight the supportive and family-friendly environment, and the childcare services. They also like the friendly and welcoming staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-efc9-743d-a3bc-50475e53f68c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-efc9-743d-a3bc-50475e53f68c",
        "storage_key": "property/6737460151192624/019d0783-efc9-743d-a3bc-50475e53f68c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://daclife.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8217653004484911464&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "dac-southaven",
      "poi_latitude": "34.9645034",
      "poi_longitude": "-89.9342356",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 662-349-0403",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b69-75ae-8831-55656b4ec903",
        "storage_key": "property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXfG-8E-Jf4gRaKG-W973CnI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_914f74e0-bf1a-4d65-a1d4-b0e530745acc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3031 Goodman Rd W, Horn Lake, MS 38637, USA",
      "poi_short_description": "Chain fitness center offering tanning and spa services as well as self-check-in stations.",
      "poi_long_description": "People say this gym offers a variety of well-maintained equipment and a hydromassage. They highlight the facility is clean and the prices are great. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-ef2d-75b0-8c21-0b9738634af2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-ef2d-75b0-8c21-0b9738634af2",
        "storage_key": "property/6737460151192624/019d0783-ef2d-75b0-8c21-0b9738634af2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/horn-lake-ms?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=7162553814127742687&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "34.9614596",
      "poi_longitude": "-90.0451241",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 662-354-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b69-75ae-8831-55656b4ec903",
        "storage_key": "property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbc9Hwa5j1YcR3w60v76AZmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_220919a6-477f-495c-bb82-32f631beccb4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "ATC Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2150 Goodman Rd E, Southaven, MS 38671, USA",
      "poi_short_description": "Members-only fitness center offering 24-hour access, free weights, tanning beds, and Wi-Fi.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-f02e-71a8-a81a-52083e3133a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-f02e-71a8-a81a-52083e3133a1",
        "storage_key": "property/6737460151192624/019d0783-f02e-71a8-a81a-52083e3133a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.atcfitness.com/locations/southaven/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17065487063667466846&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "atc-fitness",
      "poi_latitude": "34.9633648",
      "poi_longitude": "-89.95155199999999",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 662-470-5201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b69-75ae-8831-55656b4ec903",
        "storage_key": "property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ_6_mG-Jf4gRXmLsTBHK1Ow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_55083f98-688b-435a-a1b1-3772280737dc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "U.S. Nails & Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "35 Goodman Rd W Suite G, Southaven, MS 38671, USA",
      "poi_short_description": "Clean nail salon for mani-pedis and other treatments, with friendly staff and a peaceful vibe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-f626-77ca-9969-8a1e1b2dc62b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-f626-77ca-9969-8a1e1b2dc62b",
        "storage_key": "property/6737460151192624/019d0783-f626-77ca-9969-8a1e1b2dc62b.webp",
        "width": 1280,
        "height": 474
      },
      "poi_business_url": "https://usnailsms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17215743771339315653&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "us-nails--spa",
      "poi_latitude": "34.9611907",
      "poi_longitude": "-89.9906797",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 662-349-4890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b69-75ae-8831-55656b4ec903",
        "storage_key": "property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI4ne2OSJf4gRxdnSQr-b6u4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_8ca905f2-f486-4e27-a052-0c4b9463416e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "CLUB4 Fitness Horn Lake",
      "poi_type": "Health and Wellness",
      "poi_address": "3828 Goodman Rd W, Horn Lake, MS 38637, USA",
      "poi_short_description": "Membership-only fitness center offering a wide range of equipment and classes, plus tanning.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-f7a7-72d3-bc6c-41e7f81a9934.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-f7a7-72d3-bc6c-41e7f81a9934",
        "storage_key": "property/6737460151192624/019d0783-f7a7-72d3-bc6c-41e7f81a9934.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.club4fitness.com/location/horn-lake/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16487176313561897874&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "club4-fitness-horn-lake",
      "poi_latitude": "34.9632151",
      "poi_longitude": "-90.0577484",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 662-253-8781",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b69-75ae-8831-55656b4ec903",
        "storage_key": "property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNf9L9uhj1YcRklsXH4E3zuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2f990ccb-75a1-4d29-b653-50f0db949636",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Desoto County Animal Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "8330 US-51 North, Southaven, MS 38671, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-f7e4-70c6-9cee-eb2f0e6f9db7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-f7e4-70c6-9cee-eb2f0e6f9db7",
        "storage_key": "property/6737460151192624/019d0783-f7e4-70c6-9cee-eb2f0e6f9db7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://desotoanimalclinic.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4466521986636089399&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "desoto-county-animal-clinic",
      "poi_latitude": "34.982601",
      "poi_longitude": "-90.01521",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 662-342-4899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b69-75ae-8831-55656b4ec903",
        "storage_key": "property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAV5bkmhi1YcRN4jqChVG_D0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_3e544895-0ee6-474a-be1c-fb439b7bc86e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Stateline Animal Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "100 Guthrie Dr, Southaven, MS 38671, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-f750-75df-8bfc-89306a708cd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-f750-75df-8bfc-89306a708cd7",
        "storage_key": "property/6737460151192624/019d0783-f750-75df-8bfc-89306a708cd7.webp",
        "width": 958,
        "height": 539
      },
      "poi_business_url": "http://statelineanimalclinic.com/?y_source=1_MTAxODcyMTYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7273113231256076176&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "stateline-animal-clinic",
      "poi_latitude": "34.96856",
      "poi_longitude": "-89.98804",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 662-350-0125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b69-75ae-8831-55656b4ec903",
        "storage_key": "property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBx-Tu-iJf4gRkD82APNJ72Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_f0798518-a98c-4b90-abd8-e170b059d245",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Sport Clips Haircuts of Southaven",
      "poi_type": "Health and Wellness",
      "poi_address": "7111 Southcrest Pkwy Suite 108, Southaven, MS 38671, USA",
      "poi_short_description": "Chain barbershop offering men's and boys' haircuts, as well as steamed towels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-fbe1-758d-bbc4-f5c1f551adbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-fbe1-758d-bbc4-f5c1f551adbe",
        "storage_key": "property/6737460151192624/019d0783-fbe1-758d-bbc4-f5c1f551adbe.webp",
        "width": 1279,
        "height": 720
      },
      "poi_business_url": "https://sportclips.com/us-tn-southaven-tn108?utm_source=google&utm_medium=link&utm_campaign=gbp&utm_content=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=8777655210634928090&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "sport-clips-haircuts-of-southaven",
      "poi_latitude": "34.9641105",
      "poi_longitude": "-89.995753",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 662-536-2234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b69-75ae-8831-55656b4ec903",
        "storage_key": "property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY0fW6O2Jf4gR2l_Aduh-0Hk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_18af20e9-315d-4a03-bc1c-2c04cadcfbc9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "SUPERCUTS",
      "poi_type": "Health and Wellness",
      "poi_address": "125 Goodman Rd W STE B, Southaven, MS 38671, USA",
      "poi_short_description": "Chain hair salon inside Walmart offering basic services for men, women, and children.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-fce8-7325-a2af-d5c7e4c840fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-fce8-7325-a2af-d5c7e4c840fd",
        "storage_key": "property/6737460151192624/019d0783-fce8-7325-a2af-d5c7e4c840fd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.supercuts.com/locations/nearme/haircut/ms/southaven/125-goodman-rd-w-ste-b/8917",
      "poi_directions_map_url": "https://maps.google.com/?cid=13499239661965192884&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "supercuts",
      "poi_latitude": "34.9611701",
      "poi_longitude": "-89.9919431",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 662-349-7347",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b69-75ae-8831-55656b4ec903",
        "storage_key": "property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRR80kVyJf4gRtK5MVfPuVrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_6d24d414-e5e2-416c-86ce-9a61da8232b2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Baptist Memorial Hospital-DeSoto",
      "poi_type": "Health and Wellness",
      "poi_address": "7601 Southcrest Pkwy, Southaven, MS 38671, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-fdf3-76bf-bbbb-4d1e56ae306c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-fdf3-76bf-bbbb-4d1e56ae306c",
        "storage_key": "property/6737460151192624/019d0783-fdf3-76bf-bbbb-4d1e56ae306c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.baptistonline.org/locations/desoto",
      "poi_directions_map_url": "https://maps.google.com/?cid=13379683637173977973&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "baptist-memorial-hospital-desoto",
      "poi_latitude": "34.9697503",
      "poi_longitude": "-89.99696229999999",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 662-772-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1c72-77fc-b928-93480e72ca38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1c72-77fc-b928-93480e72ca38",
        "storage_key": "property/6737460151192624/019d0784-1c72-77fc-b928-93480e72ca38.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJI7JXH-GJf4gRdYPcIGEvrrk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_60309c80-a16e-4912-9d21-f5c67f435024",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Methodist South Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1300 Wesley Dr, Memphis, TN 38116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-fde6-7569-bfce-ab54a94fa0de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-fde6-7569-bfce-ab54a94fa0de",
        "storage_key": "property/6737460151192624/019d0783-fde6-7569-bfce-ab54a94fa0de.webp",
        "width": 1000,
        "height": 736
      },
      "poi_business_url": "https://direc.to/iJwK",
      "poi_directions_map_url": "https://maps.google.com/?cid=8453788500990088762&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "methodist-south-hospital",
      "poi_latitude": "35.0331139",
      "poi_longitude": "-90.0215873",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 901-516-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1c72-77fc-b928-93480e72ca38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1c72-77fc-b928-93480e72ca38",
        "storage_key": "property/6737460151192624/019d0784-1c72-77fc-b928-93480e72ca38.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZwWoesli1YcROtbL_9njUXU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_cbd9d522-2619-47bb-9bf7-3be7f78538e1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Snowden Grove Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6450 Getwell Rd, Southaven, MS 38672, USA",
      "poi_short_description": "Large venue hosting a variety of events including concerts, baseball games and soccer matches.",
      "poi_long_description": "People say this park offers a playground, ball fields, and an outdoor concert venue. They highlight the playground is fenced-in and suitable for young children, and the stage is outstanding for concerts. They also like the convenient parking. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-024e-7627-9424-d765dc623e05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0784-024e-7627-9424-d765dc623e05",
        "storage_key": "property/6737460151192624/019d0784-024e-7627-9424-d765dc623e05.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.snowdengrovebaseball.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9747122556773991372&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "snowden-grove-park",
      "poi_latitude": "34.9527622",
      "poi_longitude": "-89.93434219999999",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 662-890-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1fc8-75db-800f-8a08b5281e82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1fc8-75db-800f-8a08b5281e82",
        "storage_key": "property/6737460151192624/019d0784-1fc8-75db-800f-8a08b5281e82.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCd3VJFaJf4gRzAO2qlK8RIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e9c7c8f6-de3b-48cd-b136-e2908e46f2f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "BlueCross Healthy Place at David Carnes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Whitehaven Lane Park, Memphis, TN 38116, USA",
      "poi_short_description": "Community-maintained park with a jogging track, a playground, a splash pad and a water play area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-04f5-7431-8e2b-479423590110.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0784-04f5-7431-8e2b-479423590110",
        "storage_key": "property/6737460151192624/019d0784-04f5-7431-8e2b-479423590110.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://parkreservation.memphistn.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15069191376413199210&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "bluecross-healthy-place-at-david-carnes-park",
      "poi_latitude": "35.0183523",
      "poi_longitude": "-90.0336684",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 901-636-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1fc8-75db-800f-8a08b5281e82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1fc8-75db-800f-8a08b5281e82",
        "storage_key": "property/6737460151192624/019d0784-1fc8-75db-800f-8a08b5281e82.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDZ2a4t1i1YcRagt9g7eFINE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bfd485c3-3803-445f-8534-6fc54ac75213",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Latimer Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5633 Tulane Rd, Horn Lake, MS 38637, USA",
      "poi_short_description": "Peaceful, clean, spacious park featuring a lake and hiking paths and tennis courts.",
      "poi_long_description": "People say this park offers tennis courts, walking trails, a large lake, and recreational areas for various outdoor sports. They highlight the well-maintained grounds, the addition of new features each year, and the convenient location. They also like the outdoor exercise equipment, new playground, and disc golf course. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-048c-72fc-bc91-d04c1b0d5ca6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0784-048c-72fc-bc91-d04c1b0d5ca6",
        "storage_key": "property/6737460151192624/019d0784-048c-72fc-bc91-d04c1b0d5ca6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hornlakeparks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3136251847080211636&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "latimer-lake-park",
      "poi_latitude": "34.9427489",
      "poi_longitude": "-90.0445565",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 662-342-3468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1fc8-75db-800f-8a08b5281e82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1fc8-75db-800f-8a08b5281e82",
        "storage_key": "property/6737460151192624/019d0784-1fc8-75db-800f-8a08b5281e82.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXwF6yXth1YcRtPRgN3A0his",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_65f5e87b-c501-4ed9-a561-d4d26a90870b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Central Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7505 Stonegate Blvd, Southaven, MS 38671, USA",
      "poi_short_description": "Spacious park, with trails and ponds for strolling and fishing, plus playgrounds and disc golf.",
      "poi_long_description": "People say this city park offers a disc golf course, playground, and walking trails. They highlight the spacious area, beautiful trees, and opportunities for various activities like hiking and fishing. They also like the safe and family-friendly atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-04d4-739c-b105-0460ec63b769.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0784-04d4-739c-b105-0460ec63b769",
        "storage_key": "property/6737460151192624/019d0784-04d4-739c-b105-0460ec63b769.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://southaven.org/facilities.aspx?search=1&CID=1&RID=4&Page=detail",
      "poi_directions_map_url": "https://maps.google.com/?cid=14900996246773169235&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "central-park",
      "poi_latitude": "34.9714025",
      "poi_longitude": "-89.9637238",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 662-890-6726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1fc8-75db-800f-8a08b5281e82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1fc8-75db-800f-8a08b5281e82",
        "storage_key": "property/6737460151192624/019d0784-1fc8-75db-800f-8a08b5281e82.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ03BZ6p-Jf4gRU_xXOCP5ys4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d095e34d-12e2-46b3-ae23-bf041a4d387e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Jim Saucier Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8710 Northwest Dr, Southaven, MS 38671, USA",
      "poi_short_description": "Peaceful area with a waterfall and a pond, plus scenic walking trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-09c0-7057-8099-3442489f269d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0784-09c0-7057-8099-3442489f269d",
        "storage_key": "property/6737460151192624/019d0784-09c0-7057-8099-3442489f269d.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://southaven.org/facilities/facility/details/Jim-Saucier-Park-11",
      "poi_directions_map_url": "https://maps.google.com/?cid=6577173809140612597&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "jim-saucier-memorial-park",
      "poi_latitude": "34.9865711",
      "poi_longitude": "-90.0040045",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 662-890-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1fc8-75db-800f-8a08b5281e82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1fc8-75db-800f-8a08b5281e82",
        "storage_key": "property/6737460151192624/019d0784-1fc8-75db-800f-8a08b5281e82.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi_j1WdBj1YcR9T3UZ7vQRls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1d3c1872-28aa-4f01-b322-dcb4be90153d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Memphis International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2491 Winchester Rd, Memphis, TN 38116, USA",
      "poi_short_description": "Airport featuring a wide range of art on display, including a museum with Asian & Judaic works.",
      "poi_long_description": "People say this airport offers a variety of restaurants and shops, and has convenient amenities like charging stations and moving walkways. They also highlight the clean and modern facilities, and the friendly and helpful staff.\n\nOther reviews mention the baggage claim can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-0af5-75c2-aad9-ac3944217e69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0784-0af5-75c2-aad9-ac3944217e69",
        "storage_key": "property/6737460151192624/019d0784-0af5-75c2-aad9-ac3944217e69.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.flymemphis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4500193527213590914&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "memphis-international-airport",
      "poi_latitude": "35.0443357",
      "poi_longitude": "-89.97661869999999",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 901-922-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1fc8-75db-800f-8d4c6b04e163.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1fc8-75db-800f-8d4c6b04e163",
        "storage_key": "property/6737460151192624/019d0784-1fc8-75db-800f-8d4c6b04e163.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJDXp3L-iHf4gRggkUgivmcz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_7e15de8d-7b23-4e8d-9fb4-4cb922c61f17",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "IRS Memphis Service Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5391-5399 Getwell Rd, Memphis, TN 38118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-0ace-774b-b62c-eeb04483fe75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0784-0ace-774b-b62c-eeb04483fe75",
        "storage_key": "property/6737460151192624/019d0784-0ace-774b-b62c-eeb04483fe75.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7190749356931123856&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "irs-memphis-service-center",
      "poi_latitude": "35.0011855",
      "poi_longitude": "-89.9386282",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-829-1040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b69-75ae-8831-55656b4ec903",
        "storage_key": "property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwehd7tuIf4gRkIq_IHGsymM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9e8b9d0a-8877-43e9-8dd5-5be39c0d223f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Google Operations Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5665 Airways Blvd, Southaven, MS 38671, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-0bb0-7614-9665-939d4647a929.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0784-0bb0-7614-9665-939d4647a929",
        "storage_key": "property/6737460151192624/019d0784-0bb0-7614-9665-939d4647a929.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://google.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5131771565897920362&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "google-operations-center",
      "poi_latitude": "34.9428839",
      "poi_longitude": "-89.9947949",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b69-75ae-8831-55656b4ec903",
        "storage_key": "property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQdLsi2-Lf4gRaq_LxQy3N0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4f1c247f-944d-47aa-bddc-6bf8640c7c68",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Nike Centerpointe",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3461 E Raines Rd, Memphis, TN 38118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-101d-73eb-baa4-5a3dcd4f6fee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0784-101d-73eb-baa4-5a3dcd4f6fee",
        "storage_key": "property/6737460151192624/019d0784-101d-73eb-baa4-5a3dcd4f6fee.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://nike.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15579978227427206339&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "nike-centerpointe",
      "poi_latitude": "35.0360078",
      "poi_longitude": "-89.9486433",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 901-366-6453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b69-75ae-8831-55656b4ec903",
        "storage_key": "property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_QPfp6If4gRw2QezqYzN9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_25e7056b-7a85-4e05-a090-cacc618a8581",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Horn Lake City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3101 Goodman Rd W, Horn Lake, MS 38637, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-115f-70b0-a57c-e166c3311258.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0784-115f-70b0-a57c-e166c3311258",
        "storage_key": "property/6737460151192624/019d0784-115f-70b0-a57c-e166c3311258.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hornlake.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10836475504145441887&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "horn-lake-city-hall",
      "poi_latitude": "34.9623366",
      "poi_longitude": "-90.0473572",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 662-393-6178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-20f5-76bd-bf55-5ea9bce377d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-20f5-76bd-bf55-5ea9bce377d5",
        "storage_key": "property/6737460151192624/019d0784-20f5-76bd-bf55-5ea9bce377d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC1ygO8Vj1YcRX6TPkQ7lYpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_62426b4e-67e8-4264-a267-ee2dfcf92e4d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "WAIGLOBAL",
      "poi_type": "Major Employers & Offices",
      "poi_address": "480 Stateline Rd E, Southaven, MS 38671, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-112f-72d8-b595-9af16fcaed8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0784-112f-72d8-b595-9af16fcaed8a",
        "storage_key": "property/6737460151192624/019d0784-112f-72d8-b595-9af16fcaed8a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.waiglobal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12755716146403487087&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "waiglobal",
      "poi_latitude": "34.9932174",
      "poi_longitude": "-89.9778137",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-877-3340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b69-75ae-8831-55656b4ec903",
        "storage_key": "property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJieU_hrSJf4gRby0YokBoBbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7e0e089b-f8ba-4d23-b44c-79f1567e13f4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Crunch Fitness - Southaven",
      "poi_type": "Health and Wellness",
      "poi_address": "570 Main St, Southaven, MS 38671, USA",
      "poi_short_description": "",
      "poi_long_description": "Reviewers describe this gym as spacious, offering varied equipment, a good environment with friendly staff, and childcare.\n\nOther reviews mention membership cancellation can be difficult and the restrooms can be neglected.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019ea7e8-92f7-7200-b661-c48ec1d4c227.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea7e8-92f7-7200-b661-c48ec1d4c227",
        "storage_key": "property/6737460151192624/019ea7e8-92f7-7200-b661-c48ec1d4c227.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://www.crunch.com/locations/southaven",
      "poi_directions_map_url": "https://maps.google.com/?cid=7543372341869599174&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "crunch-fitness---southaven",
      "poi_latitude": "34.9937179",
      "poi_longitude": "-90.0002914",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 662-210-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b69-75ae-8831-55656b4ec903",
        "storage_key": "property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLzmzIFpj1YcRxtmkrS1xr2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ea9eef06-41cc-4683-b24a-4433f9d09241",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Landers Center",
      "poi_type": "Entertainment",
      "poi_address": "4560 Venture Dr, Southaven, MS 38671, USA",
      "poi_short_description": "Home of the NBA G League's Memphis Hustle, this venue hosts concerts, comedy, and more.",
      "poi_long_description": "People say this event venue hosts great concerts, graduations, and sporting events. They also highlight the clean facilities, ample parking, and helpful staff.\n\nOther reviews mention the seating can be cramped.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019ea7e8-938e-7360-9f63-6465de5ea8b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea7e8-938e-7360-9f63-6465de5ea8b3",
        "storage_key": "property/6737460151192624/019ea7e8-938e-7360-9f63-6465de5ea8b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.landerscenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7059398108476825368&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "landers-center",
      "poi_latitude": "34.9270516",
      "poi_longitude": "-89.99652549999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 662-280-9120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b69-75ae-8831-55656b4ec903",
        "storage_key": "property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-zPClHSKf4gRGF_TZy0F-GE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_6cc67afc-64ba-402b-a2c2-c20b56f9f3a8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Silo Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "2903 May Blvd #102, Southaven, MS 38672, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019ea7e8-954a-74cb-9654-52f17cbf5f3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea7e8-954a-74cb-9654-52f17cbf5f3e",
        "storage_key": "property/6737460151192624/019ea7e8-954a-74cb-9654-52f17cbf5f3e.webp",
        "width": 1276,
        "height": 1142
      },
      "poi_business_url": "https://www.silosquarems.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=273841459880375273&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "silo-square",
      "poi_latitude": "34.9537773",
      "poi_longitude": "-89.9381408",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 662-932-8726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-1b69-75ae-8831-55656b4ec903",
        "storage_key": "property/6737460151192624/019d0784-1b69-75ae-8831-55656b4ec903.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWmyIeKJf4gR6bPxXFvhzAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cc34f1f3-4c1b-4b9d-a5e1-1678322fd9bb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "poi_name": "Southaven Towne Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "6565 Towne Center Loop, Southaven, MS 38671, USA",
      "poi_short_description": "Spacious outdoor shopping plaza with familiar chains, department stores & informal restaurants.",
      "poi_long_description": "Spacious outdoor shopping plaza with familiar chains, department stores & informal restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019ea7e8-9306-763a-8a5f-561d10ca5356.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea7e8-9306-763a-8a5f-561d10ca5356",
        "storage_key": "property/6737460151192624/019ea7e8-9306-763a-8a5f-561d10ca5356.webp",
        "width": 1280,
        "height": 701
      },
      "poi_business_url": "https://southaventownecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5239656879164126513&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "southaven-towne-center",
      "poi_latitude": "34.9557183",
      "poi_longitude": "-89.995685",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 731-668-7621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0784-16e1-7028-96eb-7afb7eba3e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0784-16e1-7028-96eb-7afb7eba3e1a",
        "storage_key": "property/6737460151192624/019d0784-16e1-7028-96eb-7afb7eba3e1a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ41zAVPiJf4gRMXWCsysAt0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    }
  ],
  "office_hours": [
    {
      "id": "custom_51174021-2f0e-4b94-bbdf-4abc24ba3223",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d4156f8a-a39d-4ebf-a433-3f96d136cc1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_96bfe8e8-6907-442c-8f2e-79ff7493fdf6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_76b4da3e-ac5b-4c32-809e-b54bc6884e8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_104a936c-dd96-4160-bf44-cbbe72bed147",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_49f50871-10cc-4700-a605-492230448bb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_e20b51df-7659-408d-b0fc-0b66b1ac5a96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "rating": "5",
      "name": "Dyamond Diva80s",
      "text": "The General Manager Dominique was so sweet and made sure my process went smoothly.",
      "date": "2026-05-01",
      "title": "false"
    },
    {
      "id": "custom_2c9904eb-37ef-4d23-a0ff-283446d605c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "rating": "5",
      "name": "Humberto Perez",
      "text": "Ms. Vivica provided us with excellent service—truly outstanding. She is incredibly personable and guided us through everything related to the application process. It was truly special treatment; I highly recommend her. Thank you!",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "custom_039fe6ee-5d59-4cab-885c-95507444ff28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "rating": "5",
      "name": "Johnnie Walker",
      "text": "Ms Vivica was very helpful with my tour and my application very polite and understanding the best in communication thkz Ms Vivica",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "custom_eb874d4d-7234-48b3-ad85-b105fb05741d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "rating": "5",
      "name": "katerrious2021",
      "text": "Dominique in the office has been a sweet girl. Since she’s been in office it’s been better. Enjoy talking to her and she helps me all the time",
      "date": "2026-03-27",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_ce89c227-1335-45a7-8a57-0e8f6a0c2c68",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019e1ded-bb93-714c-9fd7-bb69997ebd46.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1ded-bb93-714c-9fd7-bb69997ebd46",
        "storage_key": "property/6737460151192624/019e1ded-bb93-714c-9fd7-bb69997ebd46.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Entrance",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=68378f68af6f144c2635f255"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993a3e-4b9c-72a1-933b-1b1b594c0c7a",
      "lead_source": "LANDING_PAGE",
      "name": "51-at-southaven",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624"
    },
    {
      "lead_collector_id": "01993a57-909c-75bf-9bd5-98a7ff00bfd6",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-51-at-southaven-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "generator",
      "page_item_url": "apartments-with-pool-in-southaven-ms",
      "search_query": "apartments with pool in Southaven MS",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Southaven, MS",
      "h2_subtitle": "Dive into comfort at our Southaven apartments with a pool. Explore our community and enjoy premium living with fantastic amenities.",
      "page_copy": "Discover a refreshing lifestyle at 51 at Southaven, where relaxation meets modern living. Our apartments with pool in Southaven, MS, provide the perfect retreat from the daily hustle. Dive into our sparkling pool and let the day's stresses float away or enjoy the serenity of our Zen garden. Here, you don’t just rent an apartment, you embrace an exceptional way of living.\n\nChoose from our spacious one, two, or three-bedroom floor plans that cater to your needs. Beyond leisure, enjoy added conveniences such as a fitness center, high-speed internet access, and a business center. Schedule a tour today and see why everyone loves calling our vibrant Southaven community home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-c90a-706a-8737-da8dca95d905.webp",
      "featured_image_media": {
        "alt_text": "Living room with a couch, coffee table, and ceiling fan.",
        "public_id": "019d0783-c90a-706a-8737-da8dca95d905",
        "storage_key": "property/6737460151192624/019d0783-c90a-706a-8737-da8dca95d905.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Southaven, MS",
      "seo_description": "Enjoy our Southaven, MS apartments with a pool. Join the vibrant community at 51 at Southaven featuring great amenities and spacious floor plans.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-in-desoto-county",
      "search_query": "fitness center apartments in Desoto County",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Desoto County",
      "h2_subtitle": "Live actively in our Desoto County apartments with a fitness center. Discover your new home in Southaven, MS.",
      "page_copy": "Welcome to 51 at Southaven, the premier choice for fitness center apartments in Desoto County. Located in the heart of Southaven, MS, our community is designed for those who crave an active lifestyle. Maintain your fitness regimen in our state-of-the-art fitness center, just steps from your door.\n\nOur community offers more than just workout facilities. You'll find spacious one, two, and three-bedroom homes complete with modern amenities, including high-speed internet and a serene Zen garden. With on-site laundry facilities and a business center, every convenience is catered to, making life at 51 at Southaven seamless and stress-free.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-c90a-706a-8737-da8dca95d905.webp",
      "featured_image_media": {
        "alt_text": "Living room with a couch, coffee table, and ceiling fan.",
        "public_id": "019d0783-c90a-706a-8737-da8dca95d905",
        "storage_key": "property/6737460151192624/019d0783-c90a-706a-8737-da8dca95d905.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Desoto County",
      "seo_description": "Discover Desoto County's top fitness center apartments. Enjoy modern amenities and spacious floor plans at 51 at Southaven in Southaven, MS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "generator",
      "page_item_url": "washer-dryer-hookup-apartments-southaven",
      "search_query": "washer dryer hookup apartments Southaven",
      "category": "Amenity",
      "h1_title": "Washer Dryer Hookup Apartments in Southaven",
      "h2_subtitle": "Enjoy the convenience of washer dryer hookup apartments in Southaven. Perfect for modern living at 51 at Southaven.",
      "page_copy": "At 51 at Southaven, we understand the importance of convenience in your everyday life. Our washer dryer hookup apartments in Southaven are designed to meet your needs. Simplify your laundry routine with in-unit hookups that save time and provide the ease of doing laundry right at home.\n\nLocated in vibrant Southaven, MS, our community offers more than just convenience. Choose from spacious one, two, or three-bedroom floor plans that feature a refreshing pool, a fitness center, and a tranquil Zen garden. Experience the perfect blend of comfort and style at 51 at Southaven, where modern amenities enhance your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-c90a-706a-8737-da8dca95d905.webp",
      "featured_image_media": {
        "alt_text": "Living room with a couch, coffee table, and ceiling fan.",
        "public_id": "019d0783-c90a-706a-8737-da8dca95d905",
        "storage_key": "property/6737460151192624/019d0783-c90a-706a-8737-da8dca95d905.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Washer Dryer Hookup Apartments in Southaven",
      "seo_description": "Discover washer dryer hookup apartments in Southaven at 51 at Southaven. Enjoy modern living with convenient amenities and spacious floor plans.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-near-38671",
      "search_query": "air conditioned apartments near 38671",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near 38671",
      "h2_subtitle": "Stay cool in our air conditioned apartments near 38671. Enjoy comfort and convenience at 51 at Southaven.",
      "page_copy": "Experience ultimate comfort at 51 at Southaven with our air conditioned apartments near 38671. Located in Southaven, MS, our community is perfect for those seeking a cool and comfortable home. Beat the heat year-round and enjoy the pleasure of a refreshing, climate-controlled environment in each of our spacious floor plans.\n\nBeyond the comfort of air conditioning, our community offers fantastic amenities including a sparkling pool, a fitness center, and a serene Zen garden. With one, two, and three-bedroom options, high-speed internet access, and on-site laundry facilities, discover why 51 at Southaven is the ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-c90a-706a-8737-da8dca95d905.webp",
      "featured_image_media": {
        "alt_text": "Living room with a couch, coffee table, and ceiling fan.",
        "public_id": "019d0783-c90a-706a-8737-da8dca95d905",
        "storage_key": "property/6737460151192624/019d0783-c90a-706a-8737-da8dca95d905.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near 38671",
      "seo_description": "Find air conditioned apartments near 38671 at 51 at Southaven. Enjoy modern amenities and a comfortable living environment in Southaven, MS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "generator",
      "page_item_url": "dishwasher-equipped-apartments-southaven",
      "search_query": "dishwasher equipped apartments Southaven",
      "category": "Amenity",
      "h1_title": "Dishwasher Equipped Apartments in Southaven",
      "h2_subtitle": "Discover the ease of living in dishwasher equipped apartments in Southaven. Experience modern convenience at 51 at Southaven.",
      "page_copy": "Upgrade your living experience at 51 at Southaven, where our dishwasher equipped apartments in Southaven offer unparalleled convenience. Say goodbye to tedious hand-washing and enjoy more quality time doing the things you love, while your modern kitchen handles the rest.\n\nSituated in the heart of Southaven, MS, our community provides more than a convenient kitchen. Choose from our selection of one, two, or three-bedroom floor plans and enjoy access to amenities like a refreshing pool, a high-quality fitness center, and a peaceful Zen garden. With features designed to enhance your lifestyle, 51 at Southaven is the optimal choice for contemporary living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-c90a-706a-8737-da8dca95d905.webp",
      "featured_image_media": {
        "alt_text": "Living room with a couch, coffee table, and ceiling fan.",
        "public_id": "019d0783-c90a-706a-8737-da8dca95d905",
        "storage_key": "property/6737460151192624/019d0783-c90a-706a-8737-da8dca95d905.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Equipped Apartments in Southaven",
      "seo_description": "Explore dishwasher equipped apartments in Southaven at 51 at Southaven. Enjoy modern conveniences and an array of amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-southaven-ms",
      "search_query": "one bedroom apartments southaven ms",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Southaven, MS",
      "h2_subtitle": "Explore spacious one bedroom apartments in Southaven, MS. Discover modern living at 51 at Southaven.",
      "page_copy": "Find the perfect retreat at 51 at Southaven, where our one bedroom apartments in Southaven, MS offer comfortable living with modern amenities. Whether you're downsizing or craving a home with personal space, our one-bedroom layouts provide the ideal balance of style and functionality.\n\nLocated in the vibrant city of Southaven, our community invites you to experience all it has to offer. From a refreshing pool, a state-of-the-art fitness center, to a tranquil Zen garden, you'll find everything you need right here. With 24-hour access and high-speed internet, 51 at Southaven is designed to meet your lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-c90a-706a-8737-da8dca95d905.webp",
      "featured_image_media": {
        "alt_text": "Living room with a couch, coffee table, and ceiling fan.",
        "public_id": "019d0783-c90a-706a-8737-da8dca95d905",
        "storage_key": "property/6737460151192624/019d0783-c90a-706a-8737-da8dca95d905.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Southaven, MS",
      "seo_description": "Locate one bedroom apartments in Southaven, MS at 51 at Southaven. Enjoy spacious layouts and modern amenities in a vibrant community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-desoto-county",
      "search_query": "two bedroom apartments desoto county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Desoto County",
      "h2_subtitle": "Discover spacious two bedroom apartments in Desoto County. Enjoy community living at 51 at Southaven.",
      "page_copy": "Welcome to 51 at Southaven, offering spacious two bedroom apartments in Desoto County designed for comfort and style. Our thoughtfully planned floor plans provide the ideal living space whether you’re sharing with a roommate or seeking extra space for a home office.\n\nLocated in picturesque Desoto County, our community elevates apartment living with amenities that include a sparkling pool, a fully-equipped fitness center, and a serene Zen garden. Enjoy the convenience of high-speed internet, on-site laundry facilities, and peace of mind with maintenance on site. Discover why 51 at Southaven is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-c90a-706a-8737-da8dca95d905.webp",
      "featured_image_media": {
        "alt_text": "Living room with a couch, coffee table, and ceiling fan.",
        "public_id": "019d0783-c90a-706a-8737-da8dca95d905",
        "storage_key": "property/6737460151192624/019d0783-c90a-706a-8737-da8dca95d905.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Desoto County",
      "seo_description": "Find two bedroom apartments in Desoto County at 51 at Southaven. Enjoy modern living, spacious layouts, and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192624",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-38671",
      "search_query": "three bedroom apartments near 38671",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 38671",
      "h2_subtitle": "Explore three bedroom apartments near 38671. Experience spacious living at 51 at Southaven.",
      "page_copy": "At 51 at Southaven, discover spacious three bedroom apartments near the 38671 area perfect for families or those craving extra room. Our elegant floor plans offer ample space, perfect for creating a home that meets your lifestyle needs.\n\nCentrally located in Southaven, MS, our community boasts a variety of extraordinary amenities, including a relaxing pool, a cutting-edge fitness center, and a tranquil Zen garden. With high-speed internet access and round-the-clock maintenance support, residing at 51 at Southaven provides convenience and peace of mind in a desirable neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192624/019d0783-c90a-706a-8737-da8dca95d905.webp",
      "featured_image_media": {
        "alt_text": "Living room with a couch, coffee table, and ceiling fan.",
        "public_id": "019d0783-c90a-706a-8737-da8dca95d905",
        "storage_key": "property/6737460151192624/019d0783-c90a-706a-8737-da8dca95d905.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 38671",
      "seo_description": "Find three bedroom apartments near 38671 at 51 at Southaven. Enjoy spacious living and top-tier amenities in a vibrant community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3360"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483085"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4707218"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=w"
    },
    {
      "ID": "custom_knock_z_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=z"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NV78B8HL"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_z_title",
      "type": "STRING",
      "value": "Zillow"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "662-642-4801"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "662-667-1116"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "662-667-1065"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "662-667-1146"
    },
    {
      "ID": "custom_knock_z_number",
      "type": "STRING",
      "value": "662-672-6368"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "662-667-1182"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "662-667-1107"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "662-642-4721"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "662-667-1080"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "662-642-4752"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "662-503-3078"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "662-339-7230"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "662-667-1198"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "662-747-4055"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "662-876-1816"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "662-733-7135"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "662-370-2861"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "662-667-1106"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "662-337-8886"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321184433"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "662-667-1078"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "662-967-4049"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "b9011ee4afc38121"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "662-265-8144"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "662-642-4827"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "662-667-1157"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "662-667-1675"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "662-667-1189"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "662-667-1168"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "662-667-1081"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.51atSouthaven.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192624/019e60c9-c4da-711e-b7b4-68ceb1d849e1.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "662-667-1139"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "662-503-3078"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3360",
  "custom_repli_id": "5028483085",
  "custom_realpage_id": "4707218",
  "custom_knock_a_link": "https://www.51atSouthaven.com?utm_knock=a",
  "custom_knock_g_link": "https://www.51atSouthaven.com?utm_knock=g",
  "custom_knock_r_link": "https://www.51atSouthaven.com?utm_knock=r",
  "custom_knock_w_link": "https://www.51atSouthaven.com?utm_knock=w",
  "custom_knock_z_link": "https://www.51atSouthaven.com?utm_knock=z",
  "custom_google_gtm_id": "GTM-NV78B8HL",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.51atSouthaven.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.51atSouthaven.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.51atSouthaven.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.51atSouthaven.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.51atSouthaven.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.51atSouthaven.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_z_title": "Zillow",
  "custom_knock_a_number": "662-642-4801",
  "custom_knock_ads_link": "https://www.51atSouthaven.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.51atSouthaven.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "662-667-1116",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.51atSouthaven.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.51atSouthaven.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.51atSouthaven.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.51atSouthaven.com?utm_knock=psa",
  "custom_knock_r_number": "662-667-1065",
  "custom_knock_w_number": "662-667-1146",
  "custom_knock_z_number": "662-672-6368",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "662-667-1182",
  "custom_knock_amap_link": "https://www.51atSouthaven.com?utm_knock=amap",
  "custom_knock_ar_number": "662-667-1107",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "662-642-4721",
  "custom_knock_fb_number": "662-667-1080",
  "custom_knock_fl_number": "662-642-4752",
  "custom_knock_gp_number": "662-503-3078",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.51atSouthaven.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "662-339-7230",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.51atSouthaven.com?utm_knock=bcard",
  "custom_knock_bnr_number": "662-667-1198",
  "custom_knock_cfres_link": "https://www.51atSouthaven.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "662-747-4055",
  "custom_knock_lgp_number": "662-876-1816",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.51atSouthaven.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "662-733-7135",
  "custom_knock_psa_number": "662-370-2861",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "662-667-1106",
  "custom_knock_bandit_link": "https://www.51atSouthaven.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.51atSouthaven.com?utm_knock=flyers",
  "custom_knock_osoc_number": "662-337-8886",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321184433",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "662-667-1078",
  "custom_knock_cfres_number": "662-967-4049",
  "custom_knock_chatgpt_link": "https://www.51atSouthaven.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "b9011ee4afc38121",
  "custom_knock_dirmail_link": "https://www.51atSouthaven.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "662-265-8144",
  "custom_knock_propbro_link": "https://www.51atSouthaven.com?utm_knock=propbro",
  "custom_knock_bandit_number": "662-642-4827",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "662-667-1157",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.51atSouthaven.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "662-667-1675",
  "custom_knock_dirmail_number": "662-667-1189",
  "custom_knock_propbro_number": "662-667-1168",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "662-667-1081",
  "custom_knock_maintenance_link": "https://www.51atSouthaven.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192624/019e60c9-c4da-711e-b7b4-68ceb1d849e1.mp4",
  "custom_knock_maintenance_number": "662-667-1139",
  "custom_ppc_tracking_phone_number": "662-503-3078"
};

export const generatedAt = '2026-10-07T17:14:07.722Z';
